(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-add-all"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.getElementById('valor-add-all');
  if (!bar) return;

  var summaryEl = bar.querySelector('.vaa-bar__summary');
  var btn = bar.querySelector('.vaa-bar__btn');

  function getItems() {
    var items = [];
    document.querySelectorAll('.vqa-wrap[data-variant-id]').forEach(function (wrap) {
      var input = wrap.querySelector('.vqa__qty-input');
      var qty = input ? Math.max(0, parseInt(input.value) || 0) : 0;
      if (qty < 1) return;
      var atcBtn = wrap.querySelector('.vqa__btn');
      if (atcBtn && atcBtn.disabled) return;
      items.push({ id: parseInt(wrap.dataset.variantId), quantity: qty, brand: wrap.dataset.productBrand || '', wrap: wrap });
    });
    return items;
  }

  function markAdded(wrap, qty) {
    if (typeof window.__valorProductCardMarkAdded === 'function') {
      window.__valorProductCardMarkAdded(wrap, qty);
      return;
    }

    var card = wrap.closest('.vpc-card, .product-card, product-card');
    if (card) card.classList.add('vpc-card--just-added', 'just-added');

    var atcBtn = wrap.querySelector('.vqa__btn');
    if (atcBtn) {
      var label = atcBtn.querySelector('.vpc-add__label, .vqa__label');
      if (label) label.textContent = 'Added · ' + qty;
      atcBtn.dataset.added = '';
      atcBtn.disabled = true;
    }

    var input = wrap.querySelector('.vqa__qty-input');
    if (input) {
      input.value = '';
      input.setAttribute('readonly', 'true');
      input.classList.add('vqa__qty-input--added');
    }
  }

  function update() {
    var items = getItems();
    var totalQty = items.reduce(function (s, i) { return s + i.quantity; }, 0);
    var variantCount = items.length;
    if (totalQty === 0) {
      bar.setAttribute('hidden', '');
      return;
    }
    bar.removeAttribute('hidden');
    summaryEl.textContent = variantCount + (variantCount === 1 ? ' variant' : ' variants') + ', ' + totalQty + ' units';
  }

  // Update on any qty input change
  document.addEventListener('input', function (e) {
    if (e.target.matches('.vqa__qty-input')) update();
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.vqa__qty-btn')) setTimeout(update, 0);
  });

  // Initial scan (cards may load after script)
  setTimeout(update, 0);

  btn.addEventListener('click', async function () {
    var items = getItems();
    if (!items.length) return;

    bar.classList.add('vaa-bar--loading');
    btn.disabled = true;

    try {
      var payload = items.map(function (item) {
        var payloadItem = { id: item.id, quantity: item.quantity };
        return payloadItem;
      });

      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: payload })
      });
      if (!res.ok) return;

      var cartData = await (await fetch('/cart.js')).json();
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { cart: cartData, resource: cartData, sourceId: '', data: { itemCount: cartData.item_count ?? 0 } }
      }));

      items.forEach(function (item) {
        markAdded(item.wrap, item.quantity);
      });

      bar.classList.remove('vaa-bar--loading');
      bar.classList.add('vaa-bar--added');
      await new Promise(function (r) { setTimeout(r, 1500); });
      bar.classList.remove('vaa-bar--added');
    } catch (_) {
    } finally {
      bar.classList.remove('vaa-bar--loading');
      btn.disabled = false;
      update();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-alert-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.vab__collapse');
  if (!btn) return;
  var banner = btn.closest('.vab');
  if (!banner) return;
  var collapsed = banner.classList.toggle('vab--collapsed');
  btn.setAttribute('aria-label', collapsed ? 'Expand alert' : 'Collapse alert');
  btn.setAttribute('title',      collapsed ? 'Expand this notice' : 'Collapse this notice');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  function vcConfirm(msg, okLabel, danger, hideCancel) {
    var dlg   = document.getElementById('vc-confirm-dialog');
    var msgEl = document.getElementById('vc-dialog-msg');
    var okBtn = document.getElementById('vc-dialog-ok');
    var canBtn = document.getElementById('vc-dialog-cancel');
    if (!dlg) return Promise.resolve(hideCancel ? (window.alert(msg), true) : window.confirm(msg));
    msgEl.textContent = msg;
    okBtn.textContent = okLabel || 'OK';
    okBtn.classList.toggle('danger', !!danger);
    canBtn.style.display = hideCancel ? 'none' : '';
    dlg.showModal();
    return new Promise(function (resolve) {
      function cleanup() { dlg.close(); okBtn.removeEventListener('click', onOk); canBtn.removeEventListener('click', onCancel); dlg.removeEventListener('cancel', onCancel); }
      function onOk()     { cleanup(); resolve(true);  }
      function onCancel() { cleanup(); resolve(false); }
      okBtn.addEventListener('click',  onOk);
      canBtn.addEventListener('click', onCancel);
      dlg.addEventListener('cancel',   onCancel);
    });
  }
  function vcAlert(msg) {
    return vcConfirm(msg, 'OK', false, true);
  }
  // Lightweight full-screen busy overlay with a spinner; returns handles to update/hide it.
  function vcShowBusy(text) {
    var overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.35);z-index:10000;display:flex;align-items:center;justify-content:center;';
    overlay.innerHTML =
      '<div style="background:#fff;border-radius:12px;padding:22px 26px;display:flex;align-items:center;gap:14px;box-shadow:0 8px 32px rgba(0,0,0,0.18);">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1D2636" stroke-width="2.5" style="animation:vc-spin 0.8s linear infinite"><circle cx="12" cy="12" r="9" stroke-dasharray="28 57" stroke-linecap="round"/></svg>' +
        '<span class="vc-busy-text" style="font-size:14px;color:#2B3A55;font-weight:500;"></span>' +
      '</div>';
    overlay.querySelector('.vc-busy-text').textContent = text || 'Loading…';
    document.body.appendChild(overlay);
    return {
      setText: function (t) { var el = overlay.querySelector('.vc-busy-text'); if (el) el.textContent = t; },
      hide: function () { overlay.remove(); },
    };
  }

  // One reload per cart visit, whatever the reason. Every trigger below is a
  // "the DOM is stale, re-render it" signal, and each one can latch if the
  // underlying state refuses to clear — which is how a stuck Blind Drop fee
  // turned into a cart that reloaded every five seconds. A second pass has
  // never fixed anything the first pass could not, so cap it and let the page
  // render instead of spinning.
  function vcReloadOnce(reason) {
    const KEY = 'vc_cart_reload_guard';
    try {
      const previous = sessionStorage.getItem(KEY);
      if (previous && Date.now() - parseInt(previous, 10) < 30000) {
        console.warn(`[ValorCartPage] suppressing repeat reload (${reason}) — already reloaded once`);
        return false;
      }
      sessionStorage.setItem(KEY, String(Date.now()));
    } catch (_) {
      // Private mode / storage disabled: fall through and reload. Without the
      // guard we are no worse off than before this existed.
    }
    window.location.reload();
    return true;
  }

  function vcRemoveBlindDropFees(cart) {
    if (window.__valorBlindDropCleanup) return window.__valorBlindDropCleanup;

    window.__valorBlindDropCleanup = (async () => {
      const currentCart = cart || await fetch('/cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      }).then((response) => {
        if (!response.ok) throw new Error(`Unable to load cart (${response.status})`);
        return response.json();
      });
      const feeLines = (currentCart.items || []).filter(
        (item) => item.handle === 'blind-drop-handling-fee'
      );

      if (!feeLines.length) {
        return { cart: currentCart, removed: false, hasFee: false };
      }

      const updates = {};
      feeLines.forEach((item) => { updates[item.key] = 0; });
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates }),
      });
      if (!response.ok) throw new Error(`Unable to remove Blind Drop fee (${response.status})`);
      const updatedCart = await response.json();

      // `removed` drives a page reload, so it has to describe what actually
      // happened rather than what we asked for. Reporting success just because
      // fee lines were FOUND turned an un-removable fee into an infinite reload:
      // every load saw the fee, POSTed the removal, reported removed=true and
      // reloaded into exactly the same state. Confirm against the cart the
      // update returned, and if the fee survived, leave it alone and let the
      // page render — a visible stray fee beats a cart nobody can load.
      const feeSurvived = (updatedCart.items || []).some(
        (item) => item.handle === 'blind-drop-handling-fee'
      );
      if (feeSurvived) {
        console.warn('[ValorCartPage] Blind Drop fee could not be removed; leaving it in place', updatedCart.items.filter((i) => i.handle === 'blind-drop-handling-fee'));
      }
      return { cart: updatedCart, removed: !feeSurvived, hasFee: feeSurvived };
    })().finally(() => { window.__valorBlindDropCleanup = null; });

    return window.__valorBlindDropCleanup;
  }

  // ── $0 lines never reach checkout ────────────────────
  // A line whose variant price is $0 is taken out of the server cart, not just
  // left out of _order, so checkout, _order and the shipping variant key all
  // describe the same items. original_price is the variant's price before
  // discounts, so a line a discount makes free is kept. Returns the cart as it
  // is after the removal; throws if the cart could not be read or updated.
  // NOTE: kept in sync with _removeZeroPriceLines in snippets/valor-cart-drawer.liquid.
  async function vcRemoveZeroPriceLines() {
    const cartRes = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!cartRes.ok) throw new Error('We could not read your cart. Please try again before continuing to checkout.');
    const cart = await cartRes.json();
    const zeroLines = (cart.items || []).filter((item) => item.original_price === 0);
    if (!zeroLines.length) return cart;

    const updates = {};
    zeroLines.forEach((item) => { updates[item.key] = 0; });
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates }),
    });
    if (!res.ok) throw new Error('We could not remove the $0 items from your cart. Please try again before continuing to checkout.');
    const updatedCart = await res.json();
    if ((updatedCart.items || []).some((item) => item.original_price === 0)) {
      throw new Error('We could not remove the $0 items from your cart. Please try again before continuing to checkout.');
    }
    return updatedCart;
  }

  // ── Delivery-location identity ───────────────────────
  // Canonical identity for a delivery location. Several ERP rows can resolve to
  // the same ship-to, and _submitMultiAddr collapses those into one copy of the
  // cart — so the count shown to the buyer, the saved selection and the cart
  // multiplier must all collapse on this same key or they drift apart.
  function vcMaKey(addr) {
    return String(addr?.bcSystemId || addr?.id || '');
  }

  // ── Multi-location quantity restore ──────────────────
  // _submitMultiAddr scales every line to base x (number of selected locations)
  // because checkout needs one full copy of the cart per delivery location. That
  // scaled cart is a checkout-only state: when the customer comes back to the
  // cart page we put the base quantities back so the page never shows (or lets
  // them edit) the inflated numbers. `_scaled` carries the pre-scale quantity
  // per line item key, which is what makes the restore exact rather than a
  // divide-by-N guess that would round badly after an inventory clamp.
  // Memoized on a shared global: valor-cart-drawer is rendered on every page,
  // including /cart, and runs the same restore during its own connectedCallback.
  // Whichever element upgrades first does the work; the other awaits this promise.
  // Deliberately never cleared — one restore per page load is correct, and a
  // second pass over a stale cart snapshot would re-POST the same quantities and
  // report a spurious change (triggering a pointless reload).
  //
  // NOTE: kept in sync with _restoreScaledCart in snippets/valor-cart-drawer.liquid.
  function vcRestoreScaledCart(cart) {
    if (window.__valorScaledCartRestore) return window.__valorScaledCartRestore;
    window.__valorScaledCartRestore = vcRestoreScaledCartUncached(cart);
    return window.__valorScaledCartRestore;
  }

  async function vcRestoreScaledCartUncached(cart) {
    let marker = null;
    try {
      const raw = cart?.attributes?._scaled;
      if (raw) marker = JSON.parse(String(raw).replace(/&quot;/g, '"'));
    } catch (_) {}
    if (!marker) return { restored: false, cart };

    // Current markers are keyed by variant id. `lines` is the older shape,
    // keyed by line item key — still honoured so a cart mid-flow when this
    // deployed is not stranded at inflated quantities.
    const byVariant = marker.items || null;
    const byKey     = marker.lines || null;
    if (!byVariant && !byKey) return { restored: false, cart };

    const n = parseInt(marker.n, 10) || 0;
    const updates = {};
    let matched = 0;
    (cart.items || []).forEach((item) => {
      const raw = byVariant ? byVariant[String(item.variant_id)] : byKey[item.key];
      const base = parseInt(raw, 10);
      if (!base || base <= 0 || n <= 1) return;
      matched++;
      // Anything added since the scale sits on top of it, so carry the delta
      // over. A line below base x n was changed by something we don't own —
      // an inventory clamp, an edit elsewhere — so leave it alone.
      const delta = item.quantity - base * n;
      if (delta < 0 || base + delta === item.quantity) return;
      updates[item.key] = base + delta;
    });

    // Only retire the marker once it has been acted on. Clearing it after
    // matching nothing is what turned a stale marker into a permanent
    // failure: the inflated cart stayed inflated with no second attempt.
    // Bounded, though: a marker that has missed three separate page loads is
    // never going to match, and an immortal one means data-vc-scaled hides the
    // cart figures on every load forever. Count the misses in the marker itself
    // so the count survives the page loads it is counting.
    if (!matched && (cart.items || []).length) {
      const tries = (parseInt(marker.tries, 10) || 0) + 1;
      const giveUp = tries >= 3;
      console.warn(`[ValorCartPage] _scaled matched no cart line (attempt ${tries}); ${giveUp ? 'retiring it' : 'leaving it in place to retry'}`, marker);
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            attributes: giveUp
              ? { _scaled: '', _lineitems: '' }
              : { _scaled: JSON.stringify(Object.assign({}, marker, { tries })) },
          }),
        });
      } catch (error) {
        console.error('[ValorCartPage] Could not update the _scaled marker', error);
      }
      return { restored: false, cart };
    }

    const body = { attributes: { _scaled: '', _lineitems: '' } };
    if (Object.keys(updates).length) body.updates = updates;

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      });
      if (!response.ok) throw new Error(`Unable to restore cart quantities (${response.status})`);
      return { restored: !!body.updates, cart: await response.json() };
    } catch (error) {
      console.error('[ValorCartPage] Multi-location quantity restore failed', error);
      return { restored: false, cart };
    }
  }

  // ── Cart file export / import ─────────────────────────
  // CSV is the interchange format for "Save to file" / "Load from file".
  // QTY plus either SKU or UPC is the minimum an imported file needs; when a
  // row carries both, SKU wins so hand-edited files behave the way the
  // customer expects. Note that Excel drops leading zeros from a UPC unless
  // the column is formatted as Text.
  const VC_FILE_COLUMNS = ['SKU', 'UPC', 'QTY', 'Title', 'Price'];

  function vcCsvCell(value) {
    const s = String(value ?? '');
    return /[",\r\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  }

  // UPCs arrive with hyphens, spaces, or as Excel numbers — compare on digits only.
  function vcNormalizeUpc(value) {
    return String(value ?? '').trim().replace(/[\s-]+/g, '');
  }

  // /cart.js carries no barcode, so the UPC column is filled from the proxy.
  // Best effort: if the lookup fails the column is simply left blank.
  async function vcFetchUpcs(items, proxy) {
    const out = {};
    const ids = [...new Set(items.map((i) => i.variant_id).filter(Boolean))];
    if (!proxy || !ids.length) return out;
    const shop = Shopify.shop.split('.')[0];
    try {
      for (let i = 0; i < ids.length; i += 200) {
        const chunk = ids.slice(i, i + 200);
        const res = await fetch(`${proxy}?action=variants&shop=${shop}&ids=${chunk.join(',')}`);
        if (!res.ok) continue;
        const data = await res.json();
        (Array.isArray(data) ? data : []).forEach((v) => {
          if (v && v.barcode) out[String(v.id)] = String(v.barcode);
        });
      }
    } catch (_) { /* leave the UPC column blank */ }
    return out;
  }

  function vcDownloadCartFile(items, cartName, upcByVariant) {
    const rows = items.map((i) => [
      i.sku || '',
      (upcByVariant && upcByVariant[String(i.variant_id)]) || '',
      i.quantity,
      i.product_title || i.title || '',
      ((i.final_price ?? 0) / 100).toFixed(2),
    ]);
    const csv = [VC_FILE_COLUMNS, ...rows].map((r) => r.map(vcCsvCell).join(',')).join('\r\n');
    const safe = (cartName || 'cart').replace(/[^\w.-]+/g, '-').replace(/^-+|-+$/g, '') || 'cart';
    const stamp = new Date().toISOString().slice(0, 10);
    // BOM so Excel opens the file as UTF-8 rather than mangling accented titles.
    const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${safe}-${stamp}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  // The cart-distribution section loads SheetJS too, so this usually resolves
  // immediately; the injection is the fallback if that section isn't present.
  let vcXlsxPromise = null;
  function vcLoadXlsx() {
    if (window.XLSX) return Promise.resolve(window.XLSX);
    if (vcXlsxPromise) return vcXlsxPromise;
    vcXlsxPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://cdn.sheetjs.com/xlsx-0.20.3/package/dist/xlsx.full.min.js';
      s.onload = () => (window.XLSX ? resolve(window.XLSX) : reject(new Error('Excel support failed to load. Please try a CSV file.')));
      s.onerror = () => reject(new Error('Excel support failed to load. Please try a CSV file.'));
      document.head.appendChild(s);
    }).catch((err) => { vcXlsxPromise = null; throw err; });
    return vcXlsxPromise;
  }

  function vcParseDelimited(text) {
    const lines = text.split(/\r?\n/).filter((l) => l.trim());
    if (!lines.length) return [];
    const sep = lines[0].includes('\t') ? '\t' : ',';
    return lines.map((line) => {
      const out = [];
      let cur = '', inQ = false;
      for (let i = 0; i < line.length; i++) {
        const ch = line[i];
        if (ch === '"' && !inQ) inQ = true;
        else if (ch === '"' && inQ && line[i + 1] === '"') { cur += '"'; i++; }
        else if (ch === '"' && inQ) inQ = false;
        else if (ch === sep && !inQ) { out.push(cur.trim()); cur = ''; }
        else cur += ch;
      }
      out.push(cur.trim());
      return out;
    });
  }

  async function vcReadCartFile(file) {
    const name = file.name.toLowerCase();
    if (name.endsWith('.xls') || name.endsWith('.xlsx')) {
      const XL = await vcLoadXlsx();
      const wb = XL.read(await file.arrayBuffer());
      const ws = wb.Sheets[wb.SheetNames[0]];
      return XL.utils.sheet_to_json(ws, { header: 1, defval: '' })
        .map((r) => r.map((c) => String(c ?? '').trim()));
    }
    return vcParseDelimited(await file.text());
  }

  // → { rows: [{ sku, upc, qty, line }], error }
  function vcRowsFromSheet(rows2d) {
    if (rows2d.length < 2) return { rows: [], error: 'That file has no data rows.' };
    const headers = rows2d[0].map((h) => String(h).toLowerCase());
    const skuCol = headers.findIndex((h) => h.includes('sku'));
    const qtyCol = headers.findIndex((h) => h.includes('qty') || h.includes('quantity'));
    const upcCol = headers.findIndex((h) => h.includes('upc') || h.includes('barcode'));
    if (qtyCol < 0 || (skuCol < 0 && upcCol < 0))
      return { rows: [], error: 'That file needs a QTY column and either a SKU or UPC column.' };

    const rows = [];
    for (let i = 1; i < rows2d.length; i++) {
      const cells = rows2d[i] || [];
      const sku = skuCol >= 0 ? String(cells[skuCol] ?? '').trim() : '';
      const upc = upcCol >= 0 ? vcNormalizeUpc(cells[upcCol]) : '';
      const qty = parseInt(cells[qtyCol], 10) || 0;
      if ((!sku && !upc) || qty <= 0) continue;
      rows.push({ sku, upc, qty, line: i + 1 });
    }
    return { rows, error: rows.length ? '' : 'No rows with a quantity above zero were found.' };
  }

  class ValorCartPage extends HTMLElement {
    async connectedCallback() {
      // The multi-ship section ships hidden from cart-distribution.liquid's own
      // stylesheet so it can't flash at the bottom of the page before this runs.
      // Pinning the inline style here keeps the two in step if that rule ever
      // stops matching (renamed section id, stylesheet stripped).
      this._distSection = document.querySelector('multi-ship')?.closest('.shopify-section') || null;
      if (this._distSection) this._distSection.style.display = 'none';

      // Resolve Cricket eligibility immediately. B2B checkout is rendered hidden,
      // so this reveals confirmed non-Cricket customers without waiting for cart
      // cleanup or any of the other asynchronous initializers below.
      this._initCricket();

      // Liquid renders the saved-cart buttons, so bind them before the awaited
      // cleanup below — they are on screen from first paint and shouldn't sit
      // inert through a /cart.js round trip. The sessionStorage handoff from the
      // account page is NOT part of this; see _loadPendingCart().
      this._initSavedCarts();

      // B2B lock: server renders an empty greyed cart; leave the hidden cart untouched.
      if (!this.hasAttribute('data-vc-locked')) {
        try {
          const renderedBlindDropFee = !!this.querySelector('[data-blind-drop-fee="true"]');
          const result = await vcRemoveBlindDropFees();
          // Reuse the cart the cleanup already fetched — no extra /cart.js round trip.
          const restore = await vcRestoreScaledCart(result.cart);
          // Reload only when the rendered page actually disagrees with the
          // cart. renderedBlindDropFee on its own is not that test: it says the
          // DOM shows a fee, not that the fee is gone. When the fee cannot be
          // removed it stays true on every load, which is how this became an
          // endless reload. Pair it with the live cart instead.
          const domShowsStaleFee = renderedBlindDropFee && !result.hasFee;
          if (result.removed || domShowsStaleFee || restore.restored) {
            // Reload rather than patch the DOM: quantity breaks and volume
            // pricing mean the Liquid-rendered unit prices, discounts and stock
            // labels all change with the restored quantities.
            if (vcReloadOnce('cart-cleanup')) return;
          }
          // Nothing to unscale, or the reload was suppressed — either way the
          // page has to become visible. Never leave the buyer on a cart the
          // data-vc-scaled CSS is still holding back.
          this.removeAttribute('data-vc-scaled');
        } catch (error) {
          this.removeAttribute('data-vc-scaled');
          console.error('[ValorCartPage] Blind Drop cleanup failed', error);
        }
      } else {
        this.removeAttribute('data-vc-scaled');
      }

      this._bindEvents();
      this._loadPendingCart();
      this._initStoreCredit();
      this._initCreditMemo();
      this._initNetTerms();
      // Keep a shared promise so an early checkout click waits for the address
      // list instead of bypassing the required delivery-location step.
      this._maReady = this._initMultiAddr()
        .catch((error) => {
          console.error('[ValorCartPage] Delivery locations failed to initialize', error);
          return false;
        })
        .finally(() => {
          const initPlaceholder = this.querySelector('#vc-cart-init');
          if (initPlaceholder) initPlaceholder.hidden = true;
        });
	  //use document.querySelector('valor-cart-page')._initStoreCredit() in the console for test

    }

    _bindEvents() {
      // Qty steppers
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-vc-step]');
        if (!btn) return;
        const line = btn.closest('[data-vc-line]');
        if (!line) return;
        const input = line.querySelector('[data-vc-qty]');
        if (!input) return;
        const step = parseInt(btn.getAttribute('data-vc-step'), 10);
        const cur = Math.max(0, parseInt(input.value || '0', 10));
        const next = Math.max(0, cur + step);
        input.value = next;
        this._updateLineAjax(line, next);
      });

      // Note toggle
      this.addEventListener('click', (e) => {
        const toggle = e.target.closest('[data-vc-note-toggle]');
        if (!toggle) return;
        const wrap = toggle.closest('.vc-note-wrap');
        wrap.classList.toggle('is-open');
        if (wrap.classList.contains('is-open')) wrap.querySelector('[data-vc-note]')?.focus();
      });

      // Note save
      this.addEventListener('change', (e) => {
        const note = e.target.closest('[data-vc-note]');
        if (!note) return;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      });

      this.addEventListener('change', (e) => {
        const input = e.target.closest('[data-vc-qty]');
        if (!input) return;
        const line = input.closest('[data-vc-line]');
        if (!line) return;
        const qty = Math.max(0, parseInt(input.value || '0', 10));
        input.value = qty;
        this._updateLineAjax(line, qty);
      });

      // Remove
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-vc-remove]');
        if (!btn) return;
        const line = btn.closest('[data-vc-line]');
        if (!line) return;
        this._updateLineAjax(line, 0, true);
      });

      // Clear cart
      this.addEventListener('click', (e) => {
        if (!e.target.closest('[data-vc-clear-cart]')) return;
        vcConfirm('Remove all items from your cart?', 'Clear cart', true).then((ok) => { if (ok) this._clearCart(); });
      });

      // Single-address checkout — write a single-entry _order so order processing
      // has the BC customer info even without the distribution component.
      const checkoutLinkEl = this.querySelector('#vc-checkout-link');
      if (checkoutLinkEl) {
        checkoutLinkEl.addEventListener('click', async (e) => {
          e.preventDefault();
          if (checkoutLinkEl.hasAttribute('data-min-order')) return;
          const href = checkoutLinkEl.href;
          checkoutLinkEl.dataset.loading = '';

          // B2B customers choose their ERP ship-to location on the cart. Waiting
          // for _maReady also prevents a fast click from falling through while
          // address-list is still loading.
          if (window.__vaAuth?.customer_id) {
            const addressStepReady = await Promise.race([
              this._maReady || Promise.resolve(false),
              new Promise((resolve) => setTimeout(() => resolve(false), 15000)),
            ]);
            // One ERP address: there is no location step to open, and none is
            // required. Fall through to the single-address contract below.
            if (!this._singleAddressCheckout) {
              if (addressStepReady && this._openAddressStep) {
                delete checkoutLinkEl.dataset.loading;
                this._openAddressStep();
                return;
              }
              delete checkoutLinkEl.dataset.loading;
              vcAlert('Shipping addresses could not be loaded. Please try again before continuing to checkout.');
              return;
            }
          }

          // A B2B order that reaches checkout without _order has no BC ship-to,
          // and the checkout address is read-only, so the buyer cannot repair it
          // there (VL6737). For B2B, every failure below keeps the buyer on the
          // cart instead of falling through to checkout with no attributes.
          const isB2B = !!window.__vaAuth?.customer_id;
          const failCheckout = (msg) => {
            delete checkoutLinkEl.dataset.loading;
            vcAlert(msg);
          };

          // Runs for every buyer, before the guest fall-through below, so no path
          // from this button reaches checkout with a $0 line still in the cart.
          let cart;
          try {
            cart = await vcRemoveZeroPriceLines();
          } catch (err) {
            console.error('[valor-cart] $0 line removal failed:', err);
            failCheckout(err.message);
            return;
          }
          if (!cart.items?.length) { window.location.reload(); return; }

          try {
            let [customerData, erpAddresses] = await Promise.all([
              window.__vaCustomerInfo,
              window.__vaGetErpAddresses ? window.__vaGetErpAddresses() : Promise.resolve(null),
            ]);
            // __vaCustomerInfo resolves null on any proxy failure, and that null
            // sticks for the page, so fetch it once more before giving up.
            if (isB2B && !(customerData?.No || customerData?.no)) {
              customerData = await this._refetchCustomerInfo();
            }
            const shipTo = customerData?.defaultShipTo || null;
            const erpNo = customerData?.No || customerData?.no || '';
            if (!erpNo) {
              if (isB2B) {
                failCheckout('We could not load your account details. Please try again before continuing to checkout.');
                return;
              }
              delete checkoutLinkEl.dataset.loading; window.location.href = href; return;
            }

            const items = {};
            if (cart?.items?.length) {
              for (const item of cart.items) {
                const vid = String(item.variant_id);
                items[vid] = (items[vid] || 0) + item.quantity;
              }
            }

            const creditMemoAttrs = this._creditMemoAttributes();
            const attrs = {
              _address_type: JSON.stringify({
                type: Array.isArray(erpAddresses) && erpAddresses.length > 0
                  ? (erpAddresses.length === 1 ? 'single' : 'multiple')
                  : 'unknown',
                company_location_id: window.__vaCurrentCompanyLocationId || '',
                bc_customer: erpNo,
                address_count: Array.isArray(erpAddresses) ? erpAddresses.length : null,
              }),
              _order: JSON.stringify([{
                id:          shipTo?.systemId   || '',
                bc_customer: shipTo?.customerNo || '',
                bc_ship_to:  shipTo?.code       || '',
                addr:        shipTo?.addr       || '',
                contact:     { name: shipTo?.contact || '', phone: shipTo?.phoneNo || '' },
                items,
                credit_memo: this._creditMemoApplied(creditMemoAttrs, shipTo?.customerNo || ''),
              }]),
              _address: JSON.stringify([{
                id:           	shipTo?.systemId          || '',
                bc_customer:   	shipTo?.customerNo        || '',
                bc_ship_to:    	shipTo?.code              || '',
                company:      	shipTo?.company           || '',
                address:       	shipTo?.address           || '',
                address2:      	shipTo?.address2          || '',
                city:          	shipTo?.city              || '',
                contact:       	shipTo?.contact           || '',
                phone:       	shipTo?.phoneNo           || '',
                country: 		shipTo?.countryRegionCode || '',
                zip:          	shipTo?.postCode          || '',
                state:         	shipTo?.state             || '',
              }]),
              _lineitems: '',
              ...creditMemoAttrs,
            };

            const _auth = window.__vaAuth;
            const variantKey = cart ? cart.items
              .map(i => `${i.variant_id}:${i.quantity}`).sort().join(',') : '';
            const [updateRes] = await Promise.all([
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: attrs }),
              }),
              (_auth && variantKey) ? fetch(_auth.proxy, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'clear-shipping-total', customer_id: _auth.customer_id, ts: _auth.ts, token: _auth.token, shop: Shopify.shop, variant_key: variantKey }),
              }).catch(() => {}) : Promise.resolve(),
            ]);
            // Proceed only when the cart Shopify returns actually carries _order.
            const updatedCart = updateRes.ok ? await updateRes.json().catch(() => null) : null;
            if (!updatedCart?.attributes?._order) {
              failCheckout('We could not save your shipping address. Please try again before continuing to checkout.');
              return;
            }
          } catch (err) {
            console.error('[valor-cart] checkout preparation failed:', err);
            if (isB2B) {
              failCheckout('We could not prepare your order. Please try again before continuing to checkout.');
              return;
            }
          }
          delete checkoutLinkEl.dataset.loading;
          window.location.href = href;
        });
      }

      // Credit memo toggle for an account with one ship-to — the cart attribute,
      // not checkout, records the choice, so it survives whichever checkout path
      // the buyer takes from here. Accounts with several locations switch it per
      // location instead (see _initCreditMemo).
      this.addEventListener('change', (e) => {
        if (!e.target.closest('[data-vc-credit-memo-toggle]')) return;
        const customerNo = this._singleAddressCustomerNo;
        if (!this._singleAddressCheckout || !customerNo) return;
        this._setCreditMemoDeclined(customerNo, !e.target.checked);
      });

      // Multi-location toggle
      this.addEventListener('click', (e) => {
        if (!e.target.closest('[data-vc-dist-toggle]')) return;
        this._toggleDistView();
      });

      // Show the legacy distribution entry on the regular cart. It is hidden
      // while valor-cart's own multi-location page is open because the two
      // multi-location implementations do not synchronize their cart state.
      const banner = this.querySelector('.vc-dist-banner');
      if (banner) {
        banner.removeAttribute('hidden');
        requestAnimationFrame(() => banner.classList.add('vc-dist-banner--show'));
      }
    }

    // Only a cart that Shopify confirms carries _order may go on to checkout:
    // without it the order reaches BC with no ship-to (VL6737). A non-2xx from
    // /cart/update.js does not reject the fetch, so check the returned cart.
    // `revertUpdates` restores pre-scale quantities before giving up.
    async _requireSavedOrder(res, revertUpdates) {
      const cart = res?.ok ? await res.json().catch(() => null) : null;
      if (cart?.attributes?._order) return;
      if (revertUpdates) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: revertUpdates }),
        }).catch(() => {});
      }
      throw new Error('We could not save your shipping address. Please try again before continuing to checkout.');
    }

    // With one-time B2B addresses disabled, checkout only accepts the current
    // Company Location's native shipping address. That location is shared by
    // every contact of the company, so whatever address the last buyer wrote
    // stays there until someone overwrites it (VL7348 showed a colleague's
    // address). Write the cart choice before every checkout, single or multi.
    async _syncCompanyLocationShipping(a) {
      const auth = window.__vaAuth;
      const companyLocationId = window.__vaCurrentCompanyLocationId || '';
      if (!auth || !companyLocationId) {
        throw new Error('We couldn’t confirm your selected shipping address. Please contact us for assistance.');
      }
      let locationUpdate;
      try {
        const response = await fetch(auth.proxy, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'company-location-shipping-update',
            customer_id: auth.customer_id,
            ts: auth.ts,
            token: auth.token,
            shop: Shopify.shop,
            company_location_id: companyLocationId,
            address: {
              company: a.name || '',
              contact: a.contact || '',
              address1: a.address1 || '',
              address2: a.address2 || '',
              city: a.city || '',
              state: a.state || '',
              zip: a.zip || '',
              country: a.country || 'US',
              phone: a.phone || '',
            },
          }),
        });
        locationUpdate = await response.json();
      } catch (_) {
        locationUpdate = null;
      }
      if (!locationUpdate?.ok) {
        console.error('[Valor checkout] Company Location shipping update failed:', locationUpdate?.error || 'No valid proxy response');
        throw new Error('We couldn’t confirm your selected shipping address. Please contact us for assistance.');
      }
    }

    // Same request and cache as layout/theme.liquid's customer-info loader,
    // which cannot be re-run once its promise has resolved to null.
    async _refetchCustomerInfo() {
      const auth = window.__vaAuth;
      if (!auth?.customer_id) return null;
      try {
        const res = await fetch(auth.proxy, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'customer-info', customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop }),
        });
        const d = res.ok ? await res.json() : null;
        const data = d?.ok ? d.data : null;
        if (data) {
          try { sessionStorage.setItem('va_info_cache-' + auth.customer_id, JSON.stringify(data)); } catch (_) {}
          window.__vaCustomerInfo = Promise.resolve(data);
        }
        return data;
      } catch (_) {
        return null;
      }
    }

    _toggleDistView() {
      const layout = this.querySelector('.vc-layout');
      const btn    = this.querySelector('[data-vc-dist-toggle]');
      const label  = btn?.querySelector('[data-vc-toggle-label]');
      const isDistMode = this.classList.contains('vc-dist-mode');

      if (isDistMode) {
        if (this._distSection) this._distSection.style.display = 'none';
        if (layout) layout.style.display = '';
        if (label) label.textContent = btn.dataset.labelDist || 'Multi-location shipping';
        this.classList.remove('vc-dist-mode');
        this._syncCreditMemo();
      } else {
        if (this._distSection) this._distSection.style.display = 'block';
        if (layout) layout.style.display = 'none';
        if (label) label.textContent = btn.dataset.labelCart || 'Simple cart view';
        this.classList.add('vc-dist-mode');
        requestAnimationFrame(() => {
          const multiShip = document.querySelector('multi-ship');
          if (!multiShip) return;
          if (multiShip._addressLoadFailed) {
            // Previous address fetch failed — retry now that the user is switching to this view
            multiShip.reloadTable();
          } else {
            multiShip.syncCartWidth();
            multiShip.syncHeaderOffset();
          }
        });
      }
    }

    _updateLineAjax(lineEl, qty, remove) {
      const variantId = lineEl.getAttribute('data-variant-id');
      if (!variantId) return;
      lineEl.style.opacity = '0.5';
      lineEl.style.pointerEvents = 'none';

      // Note: /cart/change.js regenerates line item keys when an order discount is applied
      // (Shopify recalculates discount allocation per item). /cart/update.js does not.
      // We use variant ID (not key) as the id to avoid stale-key 400 errors.
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: remove ? 0 : qty }),
      })
        .then(async (r) => {
          if (!r.ok) {
            // 422 = quantity exceeds inventory — re-fetch real cart and snap input back
            const errData = await r.json().catch(() => ({}));
            const cart = await fetch('/cart.js').then((c) => c.json()).catch(() => null);
            lineEl.style.opacity = '1';
            lineEl.style.pointerEvents = '';
            if (cart) {
              const actual = cart.items.find((i) => String(i.variant_id) === variantId);
              const actualQty = actual ? actual.quantity : 0;
              const qtyInput = lineEl.querySelector('[data-vc-qty]');
              if (qtyInput) qtyInput.value = actualQty;
              const unitCents = parseInt(lineEl.getAttribute('data-unit'), 10) || 0;
              const subEl = lineEl.querySelector('[data-vc-subtotal]');
              if (subEl) subEl.textContent = this._money((unitCents * actualQty) / 100);
              this._applyCartData(cart);
            }
            const msg = errData.description || errData.message || 'Quantity not available';
            const errEl = lineEl.querySelector('.vc-qty-error') || Object.assign(document.createElement('div'), { className: 'vc-qty-error' });
            errEl.textContent = msg;
            if (!errEl.parentNode) lineEl.appendChild(errEl);
            setTimeout(() => errEl.remove(), 4000);
            return;
          }
          const cart = await r.json();
          if (remove || qty === 0) {
            lineEl.style.transform = 'translateX(12px)';
            lineEl.style.opacity = '0';
            setTimeout(() => {
              lineEl.remove();
              this._applyCartData(cart);
            }, 200);
          } else {
            lineEl.style.opacity = '1';
            lineEl.style.pointerEvents = '';
            const unitCents = parseInt(lineEl.getAttribute('data-unit'), 10) || 0;
            const subEl = lineEl.querySelector('[data-vc-subtotal]');
            if (subEl) subEl.textContent = this._money((unitCents * qty) / 100);
            this._applyCartData(cart);
          }
        })
        .catch(() => {
          lineEl.style.opacity = '1';
          lineEl.style.pointerEvents = '';
        });
    }

    _clearCart() {
      const items = {};
      this.querySelectorAll('[data-vc-line]').forEach((el) => {
        const key = el.getAttribute('data-key');
        if (key) items[key] = 0;
      });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: items }),
      })
        .then((r) => r.json())
        .then(() => { location.reload(); });
    }

    _applyCartData(cart) {
      const total = cart.total_price;
      const itemCount = cart.item_count;
      const lineCount = cart.items ? cart.items.length : 0;

      // Head meta
      const lineCountEl = this.querySelector('[data-vc-line-count]');
      if (lineCountEl) lineCountEl.textContent = lineCount + (lineCount === 1 ? ' line item' : ' line items');
      const totalUnitsEl = this.querySelector('[data-vc-total-units]');
      if (totalUnitsEl) totalUnitsEl.textContent = itemCount.toLocaleString('en-US');

      // Summary stats
      const statLines = this.querySelector('[data-vc-stat-lines]');
      if (statLines) statLines.textContent = lineCount;
      const statUnits = this.querySelector('[data-vc-stat-units]');
      if (statUnits) statUnits.textContent = itemCount.toLocaleString('en-US');

      // Totals
      const subDisplay = this.querySelector('[data-vc-subtotal-display]');
      if (subDisplay) subDisplay.textContent = this._money((cart.original_total_price ?? total) / 100);
      const productDiscount = (cart.original_total_price ?? 0) - (cart.items_subtotal_price ?? total);
      const savingsRow     = this.querySelector('[data-vc-savings-row]');
      const savingsDisplay = this.querySelector('[data-vc-savings-display]');
      if (savingsRow) savingsRow.hidden = productDiscount <= 0;
      if (savingsDisplay) savingsDisplay.textContent = '\u2212' + this._money(productDiscount / 100);
      const grandTotal = this.querySelector('[data-vc-grand-total]');
      if (grandTotal) grandTotal.textContent = this._money((cart.items_subtotal_price ?? total) / 100);

      // Min order gate ($25) — use original_total_price (pre-discount) so credit memos don't block checkout
      const checkoutLink = this.querySelector('#vc-checkout-link');
      const belowMin = (cart.original_total_price ?? total) < 2500;
      if (checkoutLink) checkoutLink.toggleAttribute('data-min-order', belowMin);

      // Freight bar
      const freightBox = this.querySelector('[data-vc-freight]');
      if (freightBox) {
        const threshold = parseInt(freightBox.getAttribute('data-threshold'), 10) || 0;
        if (threshold > 0) {
          const fill = this.querySelector('[data-vc-freight-fill]');
          const pct = Math.min(100, Math.round((total / threshold) * 100));
          if (fill) fill.style.width = pct + '%';
        }
      }

      // Cart count bubble (theme header)
      const displayCount = itemCount > 99 ? '99+' : (itemCount || '');
      const countEls = document.querySelectorAll('[data-cart-count], .cart-count, .cart-bubble__text-count');
      countEls.forEach((el) => {
        el.textContent = displayCount;
        if (el.classList.contains('cart-bubble__text-count')) {
          el.dataset.cartCountValue = String(itemCount || 0);
          el.classList.toggle('hidden', itemCount === 0);
        }
      });
      document.querySelectorAll('.cart-bubble').forEach((el) => {
        el.classList.toggle('visually-hidden', itemCount === 0);
      });
      document.querySelectorAll('cart-icon').forEach((el) => {
        el.classList.toggle('header-actions__cart-icon--has-cart', itemCount > 0);
      });

      // Empty state
      if (lineCount === 0) {
        const linesContainer = this.querySelector('[data-vc-cart-lines]');
        if (linesContainer) {
          linesContainer.innerHTML = '<div class="vc-empty"><p>Your cart is empty.</p><a href="/collections/all" class="vc-btn-outline" style="display:inline-flex;margin-top:16px;">Browse products</a></div>';
        }
      }

      // Multi-address: update cart cache; re-fetch rates for checked, clear for unchecked
      this._maCartData = cart;
      const maList = this.querySelector('#vc-ma-list');
      if (maList) {
        maList.querySelectorAll('.vc-ma-check').forEach(cb => {
          const rateEl = cb.closest('.vc-ma-item')?.querySelector('.vc-ma-item-rate');
          if (!rateEl) return;
          if (cb.checked) {
            rateEl.innerHTML = '';
            this._fetchMaRate(parseInt(cb.dataset.idx), rateEl);
          } else {
            rateEl.innerHTML = '';
          }
        });
      }
    }

    _money(amount) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
    }

    // ── Cricket-Wireless single-address mode ─────────────────
    async _initCricket() {
      const auth = window.__vaAuth;
      if (!auth?.customer_id) return;

      // Hide checkout immediately — restored below when the market is not
      // CRICKET. For B2B customers the restore is _initMultiAddr's job instead:
      // it shows the button only when there is a single ERP address, and leaves
      // it hidden behind the delivery-location step when there are several.
      const checkoutLink = this.querySelector('#vc-checkout-link');
      if (checkoutLink) checkoutLink.style.display = 'none';
      const ownsCheckoutLink = !this.hasAttribute('data-vc-b2b');

      const customerData = await window.__vaCustomerInfo;
      if (!customerData) { if (checkoutLink && ownsCheckoutLink) checkoutLink.style.display = ''; return; }

      const market = (customerData.shopifyMarketHandle || customerData.ShopifyMarketHandle || '').toUpperCase();
      if (market !== 'CRICKET-WIRELESS') { if (checkoutLink && ownsCheckoutLink) checkoutLink.style.display = ''; return; }

      // CRICKET-WIRELESS: keep checkout hidden, show export, hide note toggle
      const exportBtn = this.querySelector('#vc-cricket-export');
      if (exportBtn) exportBtn.hidden = false;
      const noteWrap = this.querySelector('.vc-note-wrap').parentNode;
      if (noteWrap) noteWrap.style.display = 'none';

      // Show shipping section
      const cricketSection = this.querySelector('#vc-cricket-shipping');
      if (cricketSection) cricketSection.hidden = false;

      // Fetch ship-to addresses from BC (same source as ERP address form, so newly added addresses appear immediately)
      let addresses = [];
      try {
        const d = await fetch(auth.proxy, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'address-list', include_children: true })
        }).then(r => r.json()).catch(() => null);
        if (d?.ok && d.addresses) addresses = d.addresses;
      } catch (_) {}

      // Sort ship-to list ascending by Code (numeric-aware, blank codes last).
      // Sorted before the options are built so the option index still maps to
      // this array for rate lookups and the XLS export.
      addresses = addresses.slice().sort((a, b) => {
        const ca = (a?.code || '').trim();
        const cb = (b?.code || '').trim();
        if (!ca || !cb) return (!ca && !cb) ? 0 : (ca ? -1 : 1);
        return ca.localeCompare(cb, undefined, { numeric: true, sensitivity: 'base' });
      });

      const addrSel = this.querySelector('#vc-cricket-addr-sel');
      if (!addrSel) return;

      if (!addresses.length) {
        addrSel.innerHTML = '<option>No addresses found</option>';
        return;
      }

      addrSel.innerHTML = '';
      addresses.forEach((a, i) => {
        const opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = (a.code ? '[' + a.code + '] ' : '') + (a.name || '') + (a.city ? ' \u2013 ' + a.city : '');
        addrSel.appendChild(opt);
      });

      // Fetch rates for initial address
      await this._fetchCricketRates(auth, addresses[0]);

      addrSel.addEventListener('change', async () => {
        const idx = parseInt(addrSel.value) || 0;
        await this._fetchCricketRates(auth, addresses[idx]);
      });

      if (exportBtn) {
        exportBtn.addEventListener('click', () => this._exportCricketXLS(addrSel, addresses, customerData));
      }
    }

    async _fetchCricketRates(auth, address) {
      const rateRow   = this.querySelector('#vc-cricket-rate-row');
      const rateCell  = this.querySelector('#vc-cricket-rate-cell');
      const exportBtn = this.querySelector('#vc-cricket-export');
      if (!rateRow || !rateCell) return;
      rateRow.hidden = false;
      rateCell.innerHTML = '<em>Fetching rates\u2026</em>';
      if (exportBtn) exportBtn.dataset.loading = '';

      try {
        if (!address.address || !address.city || !address.postCode) {
          rateCell.innerHTML = '<em>Address incomplete</em>';
          return;
        }

        // Get cart totals
        let subtotal = 0, weight = 0;
        try {
          const r = await fetch('/cart.js');
          const cart = await r.json();
          subtotal = (cart.original_total_price ?? cart.total_price ?? 0) / 100;
          weight   = (cart.items || []).reduce((s, i) => s + (i.grams || 0) * (i.quantity || 0), 0) / 453.592;
        } catch (_) {}

        let data = null;
        try {
          const resp = await fetch(auth.proxy, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop,
              action: 'checkout-options',
              subtotal, weight: weight || 0.01,
              ship_to: {
                name:     address.name     || '',
                address1: address.address  || '',
                address2: address.address2 || '',
                city:     address.city     || '',
                state:    address.county   || '',
                zip:      address.postCode || '',
                country:  address.countryRegionCode || 'US',
                phone:    address.phoneNo  || '',
              }
            })
          });
          const result = await resp.json();
          if (!result.ok) throw new Error(result.error || 'API error');
          data = result.data || {};
        } catch (err) {
          let msg = err.message.replace(/^HTTP \d+ - /, '').replace(/^[^:]+:\s*/, '').replace(/\s*\([^)]+\)\s*$/, '').trim();
          rateCell.innerHTML = '<em>' + msg + '</em>';
          return;
        }

        const rates      = data.rateOptions || [];
        const validRates = rates.filter(r => {
          if (r.errorMessages && r.errorMessages.length > 0) return false;
          const name = (r.serviceDisplayName || ((r.carrierFriendlyName || '') + ' ' + (r.serviceCode || ''))).toLowerCase();
          return !name.includes('pickup');
        });

        if (!validRates.length) {
          rateCell.innerHTML = '<em>No rates available</em>';
          return;
        }

        const select = document.createElement('select');
        select.id = 'vc-cricket-rate-select';
        for (const rate of validRates) {
          const price = rate.buyerFreightChargeLCY ?? rate.amount ?? 0;
          const name  = rate.serviceDisplayName || ((rate.carrierFriendlyName || '') + ' ' + (rate.serviceCode || '')).trim();
          const opt   = document.createElement('option');
          opt.value        = price;
          opt.dataset.erp  = JSON.stringify({ agent: rate.bcShippingAgentCode ?? null, service: rate.bcShippingAgentServiceCode ?? null });
          opt.textContent  = price == 0 ? name + ' - Free Shipping' : name + ' - $' + Number(price).toFixed(2);
          select.appendChild(opt);
        }
        rateCell.innerHTML = '';
        rateCell.appendChild(select);
      } finally {
        if (exportBtn) delete exportBtn.dataset.loading;
      }
    }

    async _exportCricketXLS(addrSel, addresses, customerData) {
      const idx     = parseInt(addrSel.value) || 0;
      const address = addresses[idx];
      // aboUseOwnCustomerNo === true  → use this company's own customerNo
      // aboUseOwnCustomerNo !== true  → use the parent company's customerNo (fallback to own)
      const ownNo    = customerData.No || customerData.no || '';
      const parentNo = customerData.parentCustomerNo || '';
      const erpNo    = customerData.aboUseOwnCustomerNo ? (ownNo || parentNo) : (parentNo || ownNo);

      const SHIP_VIA_MAP = [
        ['Pick-Up',           'PICK-UP', 'PICK-UP'],
        ['Ground Shipping',   'FEDEX',   'GND'],
        ['Next-Day Shipping', 'FEDEX',   '1DP'],
        ['2-Day Shipping',    'FEDEX',   '2DA'],
        ['3-Day Shipping',    'FEDEX',   '3DS'],
      ];
      const resolveShipVia = (agent, service) => {
        for (const [out, a, s] of SHIP_VIA_MAP)
          if (agent === a && service === s) return out;
        return agent && service ? agent + ' ' + service : agent || service || '';
      };

      let shipVia = '';
      const rateSel = this.querySelector('#vc-cricket-rate-select');
      if (rateSel) {
        let erp = {};
        try { erp = JSON.parse(rateSel.options[rateSel.selectedIndex]?.dataset.erp || '{}'); } catch (_) {}
        shipVia = resolveShipVia(erp.agent || '', erp.service || '');
      }

      let items = [];
      try {
        const r = await fetch('/cart.js');
        const cart = await r.json();
        items = cart.items || [];
      } catch (_) {}

      const vendorId  = '2012';
      const shipToCode = address.code || address.bcShipToCode || '';
      const acctId    = erpNo;

      // Order rows for the template's "Order Details" sheet (its header is already row 1).
      const dataRows = [];
      for (const item of items) {
        if (!item.quantity) continue;
        dataRows.push([shipToCode, vendorId, item.sku || '', item.quantity, shipVia, acctId, '']);
      }
      if (!dataRows.length) return;

      // Load the customer-provided template (base64 in a theme asset) and JSZip on demand.
      if (!window.__vcExportTemplateB64) {
        const tplUrl = this.dataset.exportTemplateUrl;
        if (!tplUrl) { vcAlert('Export template is unavailable. Please try again later.'); return; }
        await new Promise((resolve, reject) => {
          const s = document.createElement('script');
          s.src = tplUrl; s.onload = resolve; s.onerror = reject;
          document.head.appendChild(s);
        });
      }
      if (!window.JSZip) {
        await new Promise((resolve, reject) => {
          const s = document.createElement('script');
          s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
          s.onload = resolve;
          s.onerror = reject;
          document.head.appendChild(s);
        });
      }

      // xlsx is a zip of XML parts. Inject rows into Order Details (sheet1.xml) only —
      // styles, sharedStrings, and the Vendor Information sheet stay byte-identical, so the
      // customer's exact display format is preserved.
      const bin = atob(window.__vcExportTemplateB64);
      const bytes = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);

      const xmlEsc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      let rowsXml = '';
      let rowNum = 2; // header occupies row 1
      for (const row of dataRows) {
        let cells = '';
        for (let ci = 0; ci < row.length; ci++) {
          const ref = String.fromCharCode(65 + ci) + rowNum;
          const val = row[ci];
          if (typeof val === 'number') {
            cells += '<c r="' + ref + '"><v>' + val + '</v></c>';
          } else if (val !== '' && val != null) {
            cells += '<c r="' + ref + '" t="inlineStr"><is><t>' + xmlEsc(val) + '</t></is></c>';
          }
        }
        rowsXml += '<row r="' + rowNum + '" spans="1:7">' + cells + '</row>';
        rowNum++;
      }
      const lastRow = rowNum - 1;

      const zip = await window.JSZip.loadAsync(bytes);

      // Order Details (sheet1): inject the order rows, bump the dimension, and mark it the
      // selected tab so the workbook opens on it (the template ships with Vendor Info active).
      const sheetPath = 'xl/worksheets/sheet1.xml';
      let sheetXml = await zip.file(sheetPath).async('string');
      sheetXml = sheetXml
        .replace('</sheetData>', rowsXml + '</sheetData>')
        .replace('<dimension ref="A1:G1"/>', '<dimension ref="A1:G' + lastRow + '"/>')
        .replace('<sheetView workbookViewId="0">', '<sheetView tabSelected="1" workbookViewId="0">');
      zip.file(sheetPath, sheetXml);

      // workbook.xml: point the active tab at the first sheet.
      if (zip.file('xl/workbook.xml')) {
        const wbXml = (await zip.file('xl/workbook.xml').async('string')).replace(/activeTab="\d+"/, 'activeTab="0"');
        zip.file('xl/workbook.xml', wbXml);
      }
      // Vendor Information (sheet2): clear its selected-tab flag so it isn't the active tab.
      if (zip.file('xl/worksheets/sheet2.xml')) {
        const s2Xml = (await zip.file('xl/worksheets/sheet2.xml').async('string')).replace(' tabSelected="1"', '');
        zip.file('xl/worksheets/sheet2.xml', s2Xml);
      }

      const blob = await zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const dlUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = dlUrl; a.download = 'cart-export.xlsx';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(dlUrl), 1000);
    }

    // ── Saved carts ───────────────────────────────────────
    _initSavedCarts() {
      const auth = window.__vaAuth;
      if (!auth?.customer_id) return;

      // Present only when Liquid rendered them (same B2B condition as the
      // __vaAuth bootstrap); every block below no-ops if they are absent.
      const saveBtn  = this.querySelector('[data-vc-save-cart]');
      const loadBtn  = this.querySelector('[data-vc-load-saved]');
      const saveFileHeadBtn = this.querySelector('[data-vc-save-file]');
      const loadFileHeadBtn = this.querySelector('[data-vc-load-file]');

      // ── Save modal ──
      const saveModal    = document.getElementById('vc-save-modal');
      const saveInput    = document.getElementById('vc-save-name');
      const saveConfirm  = document.getElementById('vc-save-confirm');
      const saveCancel   = document.getElementById('vc-save-cancel');
      const saveErr      = document.getElementById('vc-save-err');
      const saveHint     = document.getElementById('vc-save-hint');
      const saveHintName = document.getElementById('vc-save-hint-name');
      let saveKnownNames = [];

      function saveCheckDuplicate() {
        const val = saveInput.value.trim();
        if (val && saveKnownNames.includes(val.toLowerCase())) {
			if (saveHintName)
	          saveHintName.textContent = val;
          saveHint.hidden = false;
        } else {
          saveHint.hidden = true;
        }
      }

      if (saveBtn && saveModal) {
        saveBtn.addEventListener('click', () => {
          saveInput.value = '';
          saveErr.hidden = true;
          saveHint.hidden = true;
          saveKnownNames = [];
          saveModal.hidden = false;
          saveInput.focus();
          // Background fetch of existing cart names for duplicate check
          if (auth.proxy && auth.customer_id) {
            fetch(auth.proxy, {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'saved-carts-list', scope: 'mine' }),
            }).then(r => r.json()).then(d => {
              if (d.ok) {
                saveKnownNames = (d.carts || []).map(c => c.name.toLowerCase());
                saveCheckDuplicate();
              }
            }).catch(() => {});
          }
        });
        saveCancel.addEventListener('click', () => { saveModal.hidden = true; });
        saveModal.addEventListener('click', (e) => { if (e.target === saveModal) saveModal.hidden = true; });
        saveInput.addEventListener('input', saveCheckDuplicate);
        saveInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') saveConfirm.click(); });

        saveConfirm.addEventListener('click', async () => {
          const name = saveInput.value.trim();
          if (!name) { saveErr.textContent = 'Please enter a name.'; saveErr.hidden = false; return; }
          saveConfirm.disabled = true;
          saveConfirm.textContent = 'Saving…';
          saveErr.hidden = true;
          try {
            const cart = await fetch('/cart.js').then((r) => r.json());
            const items = (cart.items || []).map((i) => ({
              variant_id: i.variant_id,
              handle:     i.handle || '',
              qty:        i.quantity,
              title:      i.product_title || i.title,
              sku:        i.sku || '',
              image:      i.image || '',
              price:      i.final_price,
            }));
            const r = await fetch(auth.proxy, {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'saved-carts-save', name, items }),
            });
            const d = await r.json();
            if (!d.ok) throw new Error(d.error || 'Save failed');
            saveHint.hidden = true;
            saveModal.hidden = true;
          } catch (err) {
            saveErr.textContent = err.message || 'Save failed.';
            saveErr.hidden = false;
          } finally {
            saveConfirm.disabled = false;
            saveConfirm.textContent = 'Save';
          }
        });

        // Save to file — downloads the cart instead of storing it on the server.
        // Two entry points run the same download: the head-row button and the
        // hidden one still in this dialog. Only the dialog path has a name to
        // work with, so from the head row the file falls back to "cart-<date>".
        [saveFileHeadBtn, document.getElementById('vc-save-file')].filter(Boolean).forEach((btn) => {
          const label = btn.querySelector('[data-vc-file-label]') || btn;
          const idle  = label.textContent;
          btn.addEventListener('click', async () => {
            saveErr.hidden = true;
            btn.disabled = true;
            label.textContent = 'Preparing…';
            try {
              const cart = await fetch('/cart.js').then((r) => r.json());
              if (!(cart.items || []).length) throw new Error('Your cart is empty.');
              const upcs = await vcFetchUpcs(cart.items, auth.proxy || window.__vaProxy);
              vcDownloadCartFile(cart.items, saveInput.value.trim(), upcs);
              saveModal.hidden = true;
            } catch (err) {
              const msg = err.message || 'Could not create the file.';
              // No dialog on screen to hold the error when fired from the head row.
              if (saveModal.hidden) vcAlert(msg);
              else { saveErr.textContent = msg; saveErr.hidden = false; }
            } finally {
              btn.disabled = false;
              label.textContent = idle;
            }
          });
        });
      }

      // ── Load modal ──
      const loadModal    = document.getElementById('vc-load-modal');
      const loadList     = document.getElementById('vc-load-list');
      const loadClose    = document.getElementById('vc-load-close');
      const loadScopeEl  = document.getElementById('vc-load-scope');
      const loadPager    = document.getElementById('vc-load-pager');
      const LD_PER_PAGE  = 8;
      const ldState      = { allCarts: [], page: 1, scope: 'mine', isParentCompany: false };

      function ldEsc(s) {
        return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      }

      function ldBuildItems(items) {
        const fmtP = (c) => c == null ? '\u2014' : '$' + (c / 100).toFixed(2);
        return '<div class="vc-sc-items">' + (items || []).map(item => {
          const img = item.image ? `<img src="${ldEsc(item.image)}" alt="" loading="lazy">` : '';
          const sku = item.sku ? 'SKU: ' + ldEsc(item.sku) : '';
          const handle = item.handle ? ldEsc(item.handle) : '';
          return `<div class="vc-sc-item"${handle ? ` data-qv-handle="${handle}"` : ''}><div class="vc-sc-item-img">${img}</div><div class="vc-sc-item-info"><div class="vc-sc-item-title">${ldEsc(item.title || 'Unknown')}</div>${sku ? `<div class="vc-sc-item-sku">${sku}</div>` : ''}</div><div class="vc-sc-item-right"><div class="vc-sc-item-qty">\u00d7${item.qty || 0}</div><div class="vc-sc-item-price">${fmtP(item.price)}</div></div></div>`;
        }).join('') + '</div>';
      }

      async function ldFetch() {
        if (!loadList) return;
        loadList.innerHTML = '<div class="vc-sc-empty">Loading\u2026</div>';
        if (loadPager) loadPager.hidden = true;
        try {
          const r = await fetch(auth.proxy, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'saved-carts-list', scope: ldState.scope }),
          });
          const d = await r.json();
          if (!d.ok) throw new Error(d.error || 'Failed to load');
          ldState.allCarts = d.carts || [];
          ldState.isParentCompany = !!d.is_parent_company;
          ldState.page = 1;
          ldRender();
        } catch (err) {
          loadList.innerHTML = `<div class="vc-sc-empty">${err.message || 'Failed to load saved carts.'}</div>`;
        }
      }

      function ldRender() {
        const total = ldState.allCarts.length;
        const pages = Math.max(1, Math.ceil(total / LD_PER_PAGE));
        if (ldState.page > pages) ldState.page = pages;
        const start = (ldState.page - 1) * LD_PER_PAGE;
        const page  = ldState.allCarts.slice(start, start + LD_PER_PAGE);
        const chevron = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
        const showOwner = ldState.scope === 'org' && page.some(c => c.owner_name);
        const ownerCls  = showOwner ? ' has-owner' : '';
        if (!total) {
          loadList.innerHTML = '<div class="vc-sc-empty">No saved carts yet.</div>';
          if (loadPager) loadPager.hidden = true;
          return;
        }
        const header = `<div class="vc-sc-row-head${ownerCls}">
          <div>Name</div>
          ${showOwner ? '<div>Company</div>' : ''}
          <div>Saved by</div>
          <div>Items</div>
          <div>Saved</div>
          <div></div>
          <div></div>
        </div>`;
        loadList.innerHTML = header + page.map((c, i) => {
          const safeName = ldEsc(c.name);
          const ownerErp = ldEsc(c.owner_erp_no || '');
          const isMine   = !c.owner_name;
          const count    = c.item_count;
          const date     = new Date(c.saved_at).toLocaleDateString();
          const panelId  = `vc-ld-panel-${start + i}`;
          const previews = (c.previews || []).map(src => `<img class="vc-sc-preview-img" src="${ldEsc(src)}" alt="" loading="lazy">`).join('');
          return `<div class="vc-sc-row${ownerCls}" data-sc-name="${safeName}" data-sc-erp="${ownerErp}">
            <div class="vc-sc-row-name-col">
              <div class="vc-sc-row-name">${safeName}</div>
              ${previews ? `<div class="vc-sc-preview-wrap">${previews}</div>` : ''}
            </div>
            ${showOwner ? `<div class="vc-sc-row-owner">${c.owner_name ? ldEsc(c.owner_name) : '<span style="font-style:italic">My company</span>'}</div>` : ''}
            <div class="vc-sc-row-user">${c.saver_email ? ldEsc(c.saver_email) : '&mdash;'}</div>
            <div class="vc-sc-row-meta">${count} line item${count != 1 ? 's' : ''}</div>
            <div class="vc-sc-row-date">${date}</div>
            <div class="vc-sc-row-actions">
              ${(isMine || ldState.isParentCompany) ? `<button class="vc-sc-txt-btn danger" data-sc-del>Delete</button>` : ''}
              <button class="vc-sc-txt-btn" data-sc-load>Load</button>
            </div>
            <button class="vc-sc-expand-btn" data-sc-expand="${panelId}" title="Show items">${chevron}</button>
            <div class="vc-sc-detail" id="${panelId}">
              <div class="vc-sc-detail-inner"></div>
            </div>
          </div>`;
        }).join('');
        const pg = ldState.page;
        const showPager = pages > 1;
        const pHtml = `<button class="vc-sc-pager-btn" id="vc-ld-prev" ${pg <= 1 ? 'disabled' : ''}>\u2190 Prev</button><span class="vc-sc-pager-info">Page ${pg} of ${pages}</span><button class="vc-sc-pager-btn" id="vc-ld-next" ${pg >= pages ? 'disabled' : ''}>Next \u2192</button>`;
        if (loadPager) { loadPager.innerHTML = pHtml; loadPager.hidden = !showPager; }
      }

      if (loadBtn && loadModal) {
        loadBtn.addEventListener('click', () => { loadModal.hidden = false; ldFetch(); });

        if (loadScopeEl) {
          loadScopeEl.addEventListener('click', (e) => {
            const btn = e.target.closest('.vc-sc-scope-btn');
            if (!btn || btn.dataset.scope === ldState.scope) return;
            ldState.scope = btn.dataset.scope;
            loadScopeEl.querySelectorAll('.vc-sc-scope-btn').forEach(b => b.classList.toggle('vc-sc-scope-btn--active', b === btn));
            ldFetch();
          });
          // Hidden by default (see markup); reveal only for stores that have child
          // locations, so there's no flash for leaf/standalone stores.
          window.__vaCustomerInfo && window.__vaCustomerInfo.then((info) => {
            if (info && (info.childCount || 0) > 0) loadScopeEl.hidden = false;
          });
        }

        // Delegated click handler — registered once to avoid stacking listeners.
        loadList.addEventListener('click', async (e) => {
          const qvItem = e.target.closest('[data-qv-handle]');
          if (qvItem && !e.target.closest('button')) {
            const handle = qvItem.dataset.qvHandle;
            if (handle && window.openQuickViewDialog) {
              window.openQuickViewDialog(`/products/${handle}?view=valor-quick-add`);
            }
            return;
          }

          const expandBtn = e.target.closest('[data-sc-expand]');
          if (expandBtn) {
            const panelId = expandBtn.dataset.scExpand;
            const panel   = document.getElementById(panelId);
            if (!panel) return;
            const isOpen  = panel.classList.contains('open');
            loadList.querySelectorAll('.vc-sc-detail.open').forEach(p => p.classList.remove('open'));
            loadList.querySelectorAll('.vc-sc-expand-btn.open').forEach(b => b.classList.remove('open'));
            if (!isOpen) {
              panel.classList.add('open');
              expandBtn.classList.add('open');
              if (!panel.dataset.loaded) {
                const inner    = panel.querySelector('.vc-sc-detail-inner');
                const row      = panel.closest('[data-sc-name]');
                const cartName = row.dataset.scName;
                const cartErp  = row.dataset.scErp || '';
                inner.innerHTML = '<div style="padding:8px 0;font-size:12px;color:var(--vc-steel,#64748b)">Loading\u2026</div>';
                try {
                  const r = await fetch(auth.proxy, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'saved-carts-load', name: cartName, owner_erp_no: cartErp }),
                  });
                  const d = await r.json();
                  panel.dataset.loaded = '1';
                  inner.innerHTML = (d.ok && d.items && d.items.length) ? ldBuildItems(d.items) : '<div style="padding:8px 0;font-size:12px;color:var(--vc-steel,#64748b)">No items.</div>';
                } catch (_) {
                  inner.innerHTML = '<div style="padding:8px 0;font-size:12px;color:var(--vc-steel,#64748b)">Could not load items.</div>';
                }
              }
            }
            return;
          }
          const row = e.target.closest('[data-sc-name]');
          if (!row) return;
          const name     = row.getAttribute('data-sc-name');
          const ownerErp = row.getAttribute('data-sc-erp') || '';
          if (e.target.closest('[data-sc-load]')) {
            await this._doLoadCart(name, ownerErp, auth, loadModal);
          } else if (e.target.closest('.vc-sc-detail')) {
            // click inside expanded detail — do nothing
          } else if (e.target.closest('[data-sc-del]')) {
            const delBtn = e.target.closest('[data-sc-del]');
            const ok = await vcConfirm(`Delete "${name}"?`, 'Delete', true);
            if (!ok) return;
            delBtn.disabled = true;
            try {
              const r = await fetch(auth.proxy, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'saved-carts-delete', name, owner_erp_no: ownerErp }),
              });
              const d = await r.json();
              if (!d.ok) throw new Error(d.error || 'Delete failed');
              ldState.allCarts = ldState.allCarts.filter(c => !(c.name === name && (c.owner_erp_no || '') === ownerErp));
              ldRender();
            } catch (err) {
              vcAlert(err.message || 'Delete failed.');
              delBtn.disabled = false;
            }
          } else {
            const btn = row.querySelector('.vc-sc-expand-btn[data-sc-expand]');
            if (btn) btn.click();
          }
        });

        loadClose.addEventListener('click', () => { loadModal.hidden = true; });
        loadModal.addEventListener('click', (e) => {
          if (e.target.id === 'vc-ld-prev') { if (ldState.page > 1) { ldState.page--; ldRender(); } }
          else if (e.target.id === 'vc-ld-next') { ldState.page++; ldRender(); }
          else if (e.target === loadModal) { loadModal.hidden = true; }
        });

        // Load from file — same replace-cart flow, sourced from a spreadsheet.
        // Both entry points (head row + hidden dialog button) show the format
        // guide first; the picker only opens from that dialog, so nobody meets
        // the file browser without having seen the expected columns.
        const loadFileBtns  = [loadFileHeadBtn, document.getElementById('vc-load-file')].filter(Boolean);
        const loadFileInput = document.getElementById('vc-load-file-input');
        const helpModal     = document.getElementById('vc-file-help-modal');
        const helpChoose    = document.getElementById('vc-file-help-choose');
        const helpCancel    = document.getElementById('vc-file-help-cancel');
        if (loadFileBtns.length && loadFileInput) {
          const openPicker = () => loadFileInput.click();
          if (helpModal && helpChoose) {
            const closeHelp = () => { helpModal.hidden = true; };
            loadFileBtns.forEach((btn) => btn.addEventListener('click', () => {
              helpModal.hidden = false;
              helpChoose.focus();
            }));
            helpChoose.addEventListener('click', () => { closeHelp(); openPicker(); });
            helpCancel?.addEventListener('click', closeHelp);
            helpModal.addEventListener('click', (e) => { if (e.target === helpModal) closeHelp(); });
            helpModal.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeHelp(); });
          } else {
            loadFileBtns.forEach((btn) => btn.addEventListener('click', openPicker));
          }
          loadFileInput.addEventListener('change', async (e) => {
            const file = e.target.files[0];
            e.target.value = '';
            if (file) await this._loadCartFromFile(file, auth, loadModal);
          });
        }
      }
    }

    // Auto-load a cart if navigated here from the account page. Kept out of
    // _initSavedCarts because it consumes the sessionStorage handoff: it must run
    // after the Blind Drop cleanup has decided whether to reload, or the reload
    // would discard the pending load along with the key.
    _loadPendingCart() {
      const auth = window.__vaAuth;
      if (!auth?.customer_id) return;
      const pending = (() => { try { return sessionStorage.getItem('vc_load_cart'); } catch (_) { return null; } })();
      if (!pending) return;
      try { sessionStorage.removeItem('vc_load_cart'); } catch (_) {}
      let cartName = pending, ownerErp = '';
      try { const p = JSON.parse(pending); cartName = p.name; ownerErp = p.ownerErp || ''; } catch (_) {}
      this._doLoadCart(cartName, ownerErp, auth, null);
    }

    async _doLoadCart(name, ownerErp, auth, modal) {
      const ok = await vcConfirm(`Load "${name}"? This will replace your current cart.`, 'Load cart', false);
      if (!ok) return;
      const busy = vcShowBusy('Checking availability…');
      try {
        const body = { customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'saved-carts-load', name };
        if (ownerErp) body.owner_erp_no = ownerErp;
        const r = await fetch(auth.proxy, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        const d = await r.json();
        if (!d.ok) throw new Error(d.error || 'Load failed');
        const requested = d.items || [];
        if (!requested.length) throw new Error('This saved cart has no items.');
        await this._applyLoadedItems(requested, auth, modal, busy, `"${name}"`);
      } catch (err) {
        busy.hide();
        vcAlert(err.message || 'Failed to load cart.');
      }
    }

    // Shared by "Load cart" and "Load from file". Validates availability before
    // touching the live cart, then replaces it. Hides `busy` before returning.
    // `extraNotes` are prepended to the summary alert by the file path.
    async _applyLoadedItems(requested, auth, modal, busy, sourceLabel, extraNotes) {
      {
        // Validate availability BEFORE clearing the live cart, so unavailable items
        // (deleted / out of stock / insufficient qty) don't cause an atomic /cart/add.js
        // to fail the whole batch and leave the cart empty.
        let items = requested;
        const skipped = [];
        try {
          const vr = await fetch(auth.proxy, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop,
              action: 'saved-carts-validate', variant_ids: requested.map((it) => it.variant_id),
            }),
          }).then((res) => res.json());
          if (vr && vr.ok && vr.variants) {
            const good = [];
            requested.forEach((it) => {
              const info = vr.variants[String(it.variant_id)];
              const max  = info ? info.maxQty : 0; // no entry => not purchasable
              if (max === null || (typeof max === 'number' && max >= it.qty)) good.push(it);
              else skipped.push(it);
            });
            items = good;
          }
        } catch (_) { /* validation unavailable — fall back to resilient add below */ }

        if (!items.length) {
          busy.hide();
          if (modal) modal.hidden = true;
          await vcAlert(`None of the items in ${sourceLabel} are currently available, so your cart was left unchanged.`);
          return;
        }

        busy.setText('Updating your cart…');
        await fetch('/cart/clear.js', { method: 'POST' });

        // Add items in chunks of 25. If a batch is still rejected (e.g. validation was
        // unavailable, or stock changed since), retry that chunk one item at a time so a
        // single bad variant can't drop the other 24.
        let addFailed = 0;
        for (let i = 0; i < items.length; i += 25) {
          const chunk = items.slice(i, i + 25);
          const res = await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: chunk.map((it) => ({ id: it.variant_id, quantity: it.qty })) }),
          });
          if (!res.ok) {
            for (const it of chunk) {
              const one = await fetch('/cart/add.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: it.variant_id, quantity: it.qty }] }),
              });
              if (!one.ok) { skipped.push(it); addFailed++; }
            }
          }
        }

        busy.hide();
        if (modal) modal.hidden = true;
        const loaded = items.length - addFailed;
        const notes = (extraNotes || []).slice();
        if (skipped.length) {
          const names = skipped.map((it) => '• ' + (it.title || it.sku || it.variant_id)).join('\n');
          notes.push(`${skipped.length} unavailable and skipped:\n\n${names}`);
        }
        if (notes.length)
          await vcAlert(`Loaded ${loaded} of ${requested.length} items.\n` + notes.join('\n\n'));
        location.reload();
      }
    }

    // "Load from file": resolve the file's rows to variants, then hand off to
    // the same validate-and-replace path the saved-cart loader uses.
    async _loadCartFromFile(file, auth, modal) {
      let rows;
      try {
        const parsed = vcRowsFromSheet(await vcReadCartFile(file));
        if (parsed.error) { await vcAlert(parsed.error); return; }
        rows = parsed.rows;
      } catch (err) {
        await vcAlert(err.message || 'Could not read that file.');
        return;
      }

      const ok = await vcConfirm(
        `Load ${rows.length} line${rows.length === 1 ? '' : 's'} from "${file.name}"? This will replace your current cart.`,
        'Load cart', false);
      if (!ok) return;

      const busy = vcShowBusy('Looking up products…');
      try {
        const proxy = auth.proxy || window.__vaProxy;
        const shop  = Shopify.shop.split('.')[0];
        const skus  = [...new Set(rows.filter((r) => r.sku).map((r) => r.sku))];
        // Only SKU-less rows need a UPC lookup — SKU wins when a row has both.
        const upcs  = [...new Set(rows.filter((r) => !r.sku && r.upc).map((r) => r.upc))];

        const lookup = async (action, param, values) => {
          const out = {};
          for (let i = 0; i < values.length; i += 200) {
            const chunk = values.slice(i, i + 200);
            const res = await fetch(`${proxy}?action=${action}&shop=${shop}&${param}=${encodeURIComponent(chunk.join(','))}`);
            if (res.ok) Object.assign(out, await res.json());
          }
          return out;
        };
        const skuData = await lookup('sku-lookup', 'skus', skus);
        const upcData = await lookup('upc-lookup', 'upcs', upcs);
        // Re-key UPC results on digits only, so formatting differences still match.
        const upcIndex = {};
        Object.keys(upcData).forEach((k) => { upcIndex[vcNormalizeUpc(k)] = upcData[k]; });

        // Merge duplicate rows so the same variant isn't added twice.
        const byVariant = new Map();
        const notFound = new Set();
        const outOfStock = new Set();
        for (const row of rows) {
          const label = row.sku || row.upc;
          const found = row.sku
            ? (skuData[row.sku] || skuData[row.sku.toUpperCase()] || skuData[row.sku.toLowerCase()])
            : upcIndex[row.upc];
          if (!found) { notFound.add(label); continue; }
          if (found.available === false) { outOfStock.add(label); continue; }
          const id = parseInt(found.variant_id, 10);
          if (!id) { notFound.add(label); continue; }
          const existing = byVariant.get(id);
          if (existing) existing.qty += row.qty;
          else byVariant.set(id, { variant_id: id, qty: row.qty, sku: row.sku || found.sku || '', title: label });
        }

        const notes = [];
        if (notFound.size)   notes.push(`Not found in the store: ${[...notFound].join(', ')}`);
        if (outOfStock.size) notes.push(`Out of stock: ${[...outOfStock].join(', ')}`);

        const requested = [...byVariant.values()];
        if (!requested.length) {
          busy.hide();
          await vcAlert(['None of the rows in that file matched a product, so your cart was left unchanged.', ...notes].join('\n\n'));
          return;
        }

        busy.setText('Checking availability…');
        await this._applyLoadedItems(requested, auth, modal, busy, `"${file.name}"`, notes);
      } catch (err) {
        busy.hide();
        await vcAlert(err.message || 'Could not load from that file.');
      }
    }

    // ── Spendback store credit ────────────────────────────
    async _initStoreCredit() {
      const auth = window.__vaAuth;
      if (!auth?.customer_id) return;

      const customerData = await window.__vaCustomerInfo;
      const market = (customerData?.shopifyMarketHandle || customerData?.ShopifyMarketHandle || '').toUpperCase();
      if (market !== 'CRICKET-WIRELESS') return;
      if ((customerData?.No || customerData?.no || '') !== 'C0000105') return;

      const cart = await fetch('/cart.js').then(r => r.json()).catch(() => null);
      const orderTotal = cart ? ((cart.original_total_price ?? cart.total_price) / 100).toFixed(2) : null;

      const reqBody = {
        customer_id: auth.customer_id, ts: auth.ts, token: auth.token,
        shop: Shopify.shop, action: 'store-credit-quote',
      };
      if (orderTotal) reqBody.order_total = orderTotal;

      const d = await fetch(auth.proxy, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqBody),
      }).then(r => r.json()).catch(() => null);

      if (!d?.ok || !d.data) return;
      const sc = d.data;

      const availEl = this.querySelector('[data-vc-sc-available]');
      const maxEl   = this.querySelector('[data-vc-sc-max]');

      if (availEl) availEl.textContent = this._money(parseFloat(sc.available));
      if (maxEl) maxEl.textContent = this._money(parseFloat(sc.maxApplicable));

      const wrap = this.querySelector('#vc-spendback-wrap');
      if (wrap) wrap.style.display = '';
      const nextWrap = this.querySelector('#vc-sc-next-wrap');
      if (nextWrap) nextWrap.style.display = '';
    }

    // Credit memo is redeemed per location. A memo belongs to the BC customer it
    // was issued to -- the account itself or one of its child locations -- and is
    // never spent on another location's goods. So an account with several
    // ship-tos gets one switch per location that has open credit, on the
    // delivery-location step, and an account with one ship-to keeps the single
    // switch on the summary. credit-function caps every location by its own
    // verified balance and by its own copy of the cart.
    async _initCreditMemo() {
      const wrap = this.querySelector('#vc-credit-memo-wrap');
      if (!wrap) return;

      // What the cart already carries, so an unchanged load skips the write.
      if (this._creditMemoWritten === undefined) {
        this._creditMemoWritten = wrap.dataset.vcCreditMemoState || '||';
      }
      this._cmCredit = {};
      this._cmDeclined = this._readCreditMemoDeclined(wrap.dataset.vcCreditMemoDeclined || '');

      // window.__vaAuth is written inline by layout/theme.liquid, so an absent
      // customer_id here means signed out rather than not yet loaded. Clear
      // instead of returning: the cart survives the sign-out, and must not keep
      // applying the previous session's credit.
      const auth = window.__vaAuth;
      if (!auth?.customer_id) {
        wrap.hidden = true;
        await this._syncCreditMemo();
        return;
      }

      // CRICKET-WIRELESS customers never reach checkout -- _initCricket keeps the
      // CTA hidden and sends them through the XLS export instead -- so a credit
      // memo is an offer they cannot take. Same test as _initCricket and
      // _initMultiAddr, and it runs before the fetch so no request is wasted.
      const customerData = await window.__vaCustomerInfo;
      const market = (customerData?.shopifyMarketHandle || customerData?.ShopifyMarketHandle || '').toUpperCase();
      if (market === 'CRICKET-WIRELESS') {
        wrap.hidden = true;
        await this._syncCreditMemo();
        return;
      }

      // include_all_children returns every location's own balance, and is also
      // what makes credit-memo.php record those balances for credit-function.
      const [result, addressStepReady] = await Promise.all([
        fetch('https://app.rnrn.us/valor/credit-memo.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ customer_id: auth.customer_id, shop: Shopify.shop, include_all_children: true }),
        }).then((response) => response.json()).catch(() => null),
        this._maReady || Promise.resolve(false),
      ]);

      const credit = {};
      if (result?.ok && result.enabled !== false) {
        Object.entries(result.creditByCustomerNo || {}).forEach(([customerNo, amount]) => {
          const value = parseFloat(amount) || 0;
          if (customerNo && value > 0) credit[customerNo] = value;
        });
      }
      console.log('[ValorCreditMemo] loaded', {
        ok: result?.ok,
        enabled: result?.enabled,
        customerNo: result?.customerNo,
        memoCount: result?.memoCount,
        creditByCustomerNo: credit,
      });

      // Without the location step or the single-address flag there is no
      // location to bind a memo to, so nothing is offered.
      if (!addressStepReady && !this._singleAddressCheckout) {
        this._cmCredit = {};
      } else {
        if (this._singleAddressCheckout && !this._singleAddressCustomerNo) {
          this._singleAddressCustomerNo = String(customerData?.defaultShipTo?.customerNo || result?.customerNo || '').trim();
        }
        this._cmCredit = credit;
      }

      this._bindMaCreditSwitches();
      this._renderMaCreditSwitches();
      this._renderCreditMemoSummary();
      this._announceCreditMemo();
      // Re-assert on every load so a stale amount from a previous visit is
      // replaced by what BC reports now.
      await this._syncCreditMemo();
    }

    // Locations the buyer switched off, from _credit_memo_declined.
    _readCreditMemoDeclined(raw) {
      const declined = new Set();
      try {
        const list = JSON.parse(raw);
        if (Array.isArray(list)) list.forEach((customerNo) => { if (customerNo) declined.add(String(customerNo)); });
      } catch (_) {}
      return declined;
    }

    _isCreditMemoDeclined(customerNo) {
      return this._cmDeclined?.has(customerNo) || false;
    }

    _setCreditMemoDeclined(customerNo, declined) {
      if (!this._cmDeclined) this._cmDeclined = new Set();
      if (declined) this._cmDeclined.add(customerNo);
      else this._cmDeclined.delete(customerNo);
      this.querySelectorAll('#vc-ma-list .vc-ma-cm-check').forEach((input) => {
        if (input.dataset.customerNo === customerNo) input.checked = !declined;
      });
      this._renderCreditMemoSummary();
      this._announceCreditMemo();
      this._syncCreditMemo();
    }

    // One switch per location row whose BC customer has open credit. Two ship-tos
    // of the same customer share that customer's one balance, so their switches
    // move together. The switch sits in its own column between the address and
    // the shipping rate; the column only takes space when some location has credit.
    _renderMaCreditSwitches() {
      const list = this.querySelector('#vc-ma-list');
      if (!list || !this._maAddresses) return;
      let anyCredit = false;
      list.querySelectorAll('.vc-ma-item').forEach((item) => {
        item.querySelector('[data-vc-ma-cm]')?.remove();
        const cb = item.querySelector('.vc-ma-check');
        const addr = this._maAddresses[parseInt(cb?.dataset.idx)];
        const customerNo = addr?.bcCustomerNo || '';
        const amount = customerNo ? this._cmCredit?.[customerNo] : 0;
        const cell = item.querySelector('.vc-ma-item-cm');
        if (!amount || !cell) return;
        anyCredit = true;

        const box = document.createElement('span');
        box.className = 'vc-ma-cm';
        box.dataset.vcMaCm = '';
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.className = 'vc-ma-cm-check';
        input.dataset.customerNo = customerNo;
        input.checked = !this._isCreditMemoDeclined(customerNo);
        input.setAttribute('aria-label', `Apply the ${this._money(amount)} credit memo of ${customerNo}`);
        const text = document.createElement('span');
        text.className = 'vc-ma-cm-text';
        text.append('Apply credit memo ');
        const strong = document.createElement('strong');
        strong.textContent = this._money(amount);
        const owner = document.createElement('span');
        owner.className = 'vc-ma-cm-owner';
        owner.textContent = ` · ${customerNo}`;
        text.append(strong, owner);
        box.append(input, text);
        cell.appendChild(box);
      });
      list.classList.toggle('vc-ma-list--cm', anyCredit);
    }

    _bindMaCreditSwitches() {
      const list = this.querySelector('#vc-ma-list');
      if (!list || this._maCreditBound) return;
      this._maCreditBound = true;
      // The row is a <label> for the location checkbox. A click on the switch's
      // text must flip the switch, not select or drop the location. A click on
      // the switch itself never reaches the label: it is interactive content.
      list.addEventListener('click', (e) => {
        const box = e.target.closest('[data-vc-ma-cm]');
        if (!box || e.target.closest('.vc-ma-cm-check')) return;
        e.preventDefault();
        const input = box.querySelector('.vc-ma-cm-check');
        if (!input) return;
        input.checked = !input.checked;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      list.addEventListener('change', (e) => {
        const input = e.target.closest('.vc-ma-cm-check');
        if (!input) return;
        this._setCreditMemoDeclined(input.dataset.customerNo, !input.checked);
      });
    }

    // The summary box: the single switch for a one-ship-to account. Accounts
    // with several locations switch each one on the location list instead.
    _renderCreditMemoSummary() {
      const wrap = this.querySelector('#vc-credit-memo-wrap');
      if (!wrap) return;
      const credit = this._cmCredit || {};
      const toggle  = wrap.querySelector('[data-vc-credit-memo-toggle]');
      const labelEl = wrap.querySelector('[data-vc-credit-memo-label]');
      const valueEl = wrap.querySelector('[data-vc-credit-memo-value]');
      const noteEl  = wrap.querySelector('[data-vc-credit-memo-note]');

      if (this._singleAddressCheckout) {
        const customerNo = this._singleAddressCustomerNo;
        const amount = customerNo ? credit[customerNo] : 0;
        wrap.hidden = !amount;
        if (!amount) return;
        if (toggle) toggle.checked = !this._isCreditMemoDeclined(customerNo);
        if (labelEl) {
          labelEl.textContent = 'Apply Valor Credit Memo';
          labelEl.setAttribute('for', 'vc-credit-memo-toggle');
        }
        if (valueEl) valueEl.textContent = this._money(amount);
        if (noteEl) noteEl.textContent = `Available on account ${customerNo} — applied at checkout, up to the order subtotal.`;
        return;
      }

      // Several locations: each has its own switch on the location list, which
      // is the whole story, so this box stays hidden.
      wrap.hidden = true;
    }

    // _credit_memo_requested lists the BC customers whose memo this checkout
    // applies, each a location on it:
    //   ["C0039954", "C0039767"]
    // Memos the buyer switched off go to _credit_memo_declined instead, a list
    // of BC customer numbers, so the switches are restored on the next visit.
    // The amounts are credit-function's to decide, from the balances
    // credit-memo.php stored on the Company and from _order, written in the
    // same update: each ship-to's items cap its location's goods credit and its
    // `buyer` rate caps its shipping credit. Quantity edits need no rewrite here.
    //
    // _credit_memo_available is not read by the function. It records, per
    // applied location, the balance the buyer was shown, for tracing a credit
    // discount back to its locations during order processing.
    _creditMemoAttributes() {
      const shipTos = this._singleAddressCheckout
        ? [this._singleAddressCustomerNo || '']
        : this._maSelectedChecks().map(({ addr }) => addr.bcCustomerNo || '');
      return this._creditMemoAttributesFor(shipTos);
    }

    // The same attributes for any checkout, from one BC customer number per
    // ship-to on it. Cart distribution passes its own ship-tos.
    _creditMemoAttributesFor(shipTos) {
      const empty = { _credit_memo_requested: '', _credit_memo_available: '', _credit_memo_declined: '' };
      const credit = this._cmCredit || {};
      if (!Object.keys(credit).length) return empty;

      const onOrder = new Set(shipTos.filter(Boolean));
      const applied = [];
      const available = {};
      const declined = [];
      Object.keys(credit).forEach((customerNo) => {
        if (this._isCreditMemoDeclined(customerNo)) {
          declined.push(customerNo);
        } else if (onOrder.has(customerNo)) {
          applied.push(customerNo);
          available[customerNo] = credit[customerNo].toFixed(2);
        }
      });
      const declinedAttr = declined.length ? JSON.stringify(declined) : '';
      if (!applied.length) return { ...empty, _credit_memo_declined: declinedAttr };

      return {
        _credit_memo_requested: JSON.stringify(applied),
        _credit_memo_available: Object.keys(available).length ? JSON.stringify(available) : '',
        _credit_memo_declined: declinedAttr,
      };
    }

    // Whether this checkout applies customerNo's memo, read from the same
    // _credit_memo_requested value written alongside _order, so each _order
    // entry's credit_memo flag always agrees with what credit-function applies.
    // The flag is for order processing only; the function never reads it.
    _creditMemoApplied(creditMemoAttrs, customerNo) {
      if (!customerNo || !creditMemoAttrs?._credit_memo_requested) return false;
      try {
        const applied = JSON.parse(creditMemoAttrs._credit_memo_requested);
        return Array.isArray(applied) && applied.includes(customerNo);
      } catch (_) {
        return false;
      }
    }

    // Cart distribution (assets/cart-distribution.js) shares this page's
    // balances and switches, and builds its checkout's credit attributes here,
    // so both views agree on what each location applies.
    creditMemoBalance(customerNo) {
      return this._cmCredit?.[customerNo] || 0;
    }

    creditMemoDeclined(customerNo) {
      return this._isCreditMemoDeclined(customerNo);
    }

    setCreditMemoDeclined(customerNo, declined) {
      this._setCreditMemoDeclined(customerNo, declined);
    }

    creditMemoAttributesFor(shipTos) {
      return this._creditMemoAttributesFor(shipTos);
    }

    creditMemoApplied(creditMemoAttrs, customerNo) {
      return this._creditMemoApplied(creditMemoAttrs, customerNo);
    }

    // Tells cart distribution to redraw its switches.
    _announceCreditMemo() {
      document.dispatchEvent(new CustomEvent('valor:credit-memo-changed'));
    }

    _creditMemoStateKey(attributes) {
      return `${attributes._credit_memo_requested}|${attributes._credit_memo_available}|${attributes._credit_memo_declined}`;
    }

    async _syncCreditMemo() {
      // Cart distribution writes its own credit attributes at checkout, from its
      // own ship-tos; this view's selection must not overwrite them meanwhile.
      // Leaving that view syncs again.
      if (this.classList.contains('vc-dist-mode')) return;
      const attributes = this._creditMemoAttributes();
      const state = this._creditMemoStateKey(attributes);
      if (state === this._creditMemoWritten) return;
      const previous = this._creditMemoWritten;
      this._creditMemoWritten = state;

      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ attributes }),
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
      } catch (error) {
        // Forget the write so the next change retries instead of assuming the
        // cart already carries a value it never received.
        this._creditMemoWritten = previous;
        console.error('[ValorCartPage] Could not update the credit memo attributes', error);
      }
    }

    // ── Multi-address checkout ────────────────────────────
    async _initMultiAddr() {
      const auth = window.__vaAuth;
      if (!auth?.customer_id) return false;

      // Blocked account: leave #vc-ma-trigger hidden and skip the ERP address
      // lookup entirely — there is no checkout to prepare shipping options for.
      if (this.hasAttribute('data-vc-checkout-blocked')) return false;

      // CRICKET-WIRELESS customers use the export flow instead of multi-location
      // copy — skip building the multi-addr UI so #vc-ma-trigger stays hidden.
      const customerData = await window.__vaCustomerInfo;
      const market = (customerData?.shopifyMarketHandle || customerData?.ShopifyMarketHandle || '').toUpperCase();
      if (market === 'CRICKET-WIRELESS') return false;

      const addressRequest = window.__vaGetErpAddresses
        ? window.__vaGetErpAddresses().then((addresses) => Array.isArray(addresses) ? { ok: true, addresses } : null)
        : fetch(auth.proxy, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              customer_id: auth.customer_id, ts: auth.ts, token: auth.token,
              shop: Shopify.shop, action: 'address-list', include_children: true,
            }),
          }).then(r => r.json()).catch(() => null);

      const [res, cartData] = await Promise.all([
        addressRequest,
        fetch('/cart.js').then(r => r.json()).catch(() => null),
      ]);

      if (!res?.ok || !res.addresses) return false;

      if (res.addresses.length === 0) return false;

      if (res.addresses.length === 1) {
        // One ERP address is not a choice, so no location step is built. The
        // checkout CTA stays on the original single-address contract handled in
        // the #vc-checkout-link listener. The flag tells that listener the
        // missing step is expected rather than a failed address load.
        this._singleAddressCheckout = true;
        // The credit memo switch on the summary belongs to this one location.
        this._singleAddressCustomerNo = String(
          res.addresses[0].bcCustomerNo || res.addresses[0].customerNo || ''
        ).trim();
        // Reveal the CTA the B2B markup renders hidden. _initCricket leaves it
        // alone for B2B, so this is the only thing that shows it, and only when
        // there is no location step to pass through first.
        const checkoutLink = this.querySelector('#vc-checkout-link');
        if (checkoutLink) checkoutLink.style.display = '';
        return false;
      }

      // Reuse this cart snapshot for rate lookups, the Order Preview scaling,
      // and (below) restoring which locations were selected before a refresh.
      this._maCartData = cartData;

      this._maAddresses = res.addresses.map(a => ({
        id:           a.code              || '',
        bcSystemId:   a.systemId          || '',
        bcCustomerNo: a.bcCustomerNo      || a.customerNo || '',
        bcShipToCode: a.bcShipToCode      || a.code       || '',
        name:         a.name              || '',
        contact:      a.contact           || '',
        addr:         [a.address, a.city, a.county, a.postCode].filter(Boolean).join(', '),
        address1:     a.address           || '',
        address2:     a.address2          || '',
        city:         a.city              || '',
        state:        a.county            || '',
        zip:          a.postCode          || '',
        country:      a.countryRegionCode || '',
        phone:        a.phoneNo           || '',
      }));

      const esc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

      const list = this.querySelector('#vc-ma-list');
      if (list) {
        list.innerHTML = this._maAddresses.map((a, i) => `
          <label class="vc-ma-item">
            <input type="checkbox" class="vc-ma-check" data-idx="${i}">
            <span class="vc-ma-item-body">
              <span class="vc-ma-item-name">${esc(a.name)}</span>
              ${a.bcShipToCode ? `<span class="vc-ma-item-code">${esc(a.bcShipToCode)}</span>` : ''}
              ${a.addr ? `<span class="vc-ma-item-addr">${esc(a.addr)}</span>` : ''}
            </span>
            <span class="vc-ma-item-cm"></span>
            <span class="vc-ma-item-rate"></span>
          </label>
        `).join('') + '<div class="vc-ma-empty" id="vc-ma-empty" hidden></div>';

        const visibleCountEl = this.querySelector('#vc-ma-visible-count');
        const submitCountEl = this.querySelector('#vc-ma-sel-count');
        const submitBtn = this.querySelector('#vc-ma-submit');
        const showSelectedBtn = this.querySelector('#vc-ma-show-selected');
        const clearBtn = this.querySelector('#vc-ma-clear');
        const searchInput = this.querySelector('#vc-ma-search');
        const searchClear = this.querySelector('#vc-ma-search-clear');
        const emptyEl = this.querySelector('#vc-ma-empty');

        // A search box over a handful of rows is just clutter; the accounts that
        // need it have dozens to hundreds of ship-tos.
        const searchWrap = this.querySelector('.vc-ma-search-wrap');
        if (searchWrap) searchWrap.hidden = this._maAddresses.length < 8;

        // Search and "show selected only" both narrow the same list, so one
        // function owns every row's `hidden`. Deciding it in two places let
        // either control re-reveal rows the other had filtered out.
        const applyItemVisibility = () => {
          const q = (searchInput?.value || '').trim().toLowerCase();
          const selectedOnly = showSelectedBtn?.getAttribute('aria-pressed') === 'true';
          let matched = 0;
          let shown = 0;
          list.querySelectorAll('.vc-ma-item').forEach((item) => {
            const cb = item.querySelector('.vc-ma-check');
            const checked = !!cb?.checked;
            // Same fields the cart-distribution address search matches on.
            const a = this._maAddresses[parseInt(cb?.dataset.idx)] || {};
            const match = !q
              || (a.name || '').toLowerCase().includes(q)
              || (a.addr || '').toLowerCase().includes(q)
              || (a.bcShipToCode || '').toLowerCase().includes(q);
            if (match) matched += 1;
            // A checked location stays on screen whatever the search says: it is
            // shipping either way, and a buyer who cannot see it cannot uncheck it.
            const visible = (match || checked) && (!selectedOnly || checked);
            item.hidden = !visible;
            if (visible) shown += 1;
          });
          if (emptyEl) {
            // Reported against the query, not against what is on screen, so the
            // selected rows held back above do not read as search results.
            const noMatches = !!q && matched === 0;
            emptyEl.hidden = !noMatches && shown > 0;
            // "other" only when selected rows are the reason something is on screen.
            emptyEl.textContent = q
              ? `No ${shown > 0 ? 'other ' : ''}location matches "${searchInput.value.trim()}".`
              : 'No locations selected yet.';
          }
        };

        searchInput?.addEventListener('input', applyItemVisibility);
        searchInput?.addEventListener('keydown', (e) => {
          if (e.key !== 'Escape' || !searchInput.value) return;
          searchInput.value = '';
          applyItemVisibility();
        });
        searchClear?.addEventListener('click', () => {
          searchInput.value = '';
          applyItemVisibility();
          searchInput.focus();
        });

        const updateSelectionControls = () => {
          // Deduped: the label must promise the number of locations that will
          // actually be shipped to, which is what _submitMultiAddr scales by.
          const count = this._maSelectedChecks().length;
          if (visibleCountEl) visibleCountEl.textContent = String(count);
          if (submitCountEl) submitCountEl.textContent = String(count);
          if (submitBtn) submitBtn.disabled = count < 1;
          if (clearBtn) clearBtn.disabled = count < 1;
          applyItemVisibility();
          return count;
        };

        showSelectedBtn?.addEventListener('click', () => {
          const selectedOnly = showSelectedBtn.getAttribute('aria-pressed') !== 'true';
          showSelectedBtn.setAttribute('aria-pressed', String(selectedOnly));
          showSelectedBtn.textContent = selectedOnly ? 'Show all addresses' : 'Show selected only';
          applyItemVisibility();
        });

        clearBtn?.addEventListener('click', () => {
          list.querySelectorAll('.vc-ma-check:checked').forEach((checkbox) => {
            checkbox.checked = false;
            const rateEl = checkbox.closest('.vc-ma-item')?.querySelector('.vc-ma-item-rate');
            if (rateEl) rateEl.innerHTML = '';
          });
          if (showSelectedBtn) {
            showSelectedBtn.setAttribute('aria-pressed', 'false');
            showSelectedBtn.textContent = 'Show selected only';
          }
          updateSelectionControls();
          this._updateMaSummary(0);
          this._saveMaSelection();
        });

        // ── Single / multi location mode ──────────────────────
        // Single is the default: one order to one destination is what nearly
        // every cart does. Multi copies the whole cart to each selected
        // location (_submitMultiAddr scales the line quantities by the selected
        // count), which is a much bigger order than the buyer may expect, so it
        // only happens after an explicit switch.
        const maViewEl = this.querySelector('#vc-ma-view');
        const subEl    = this.querySelector('#vc-ma-sub');
        const modeBtns = this.querySelectorAll('[data-vc-ma-mode]');

        // Keep only `keep` checked, and clear the rate cell of every row that is
        // no longer selected. Native radios uncheck the previous row without
        // firing a change event on it, so the stale quote it was showing has to
        // be cleared from here rather than by that row's own handler.
        const collapseToOne = (keep) => {
          list.querySelectorAll('.vc-ma-item').forEach((item) => {
            const cb = item.querySelector('.vc-ma-check');
            if (!cb) return;
            if (cb !== keep && cb.checked) cb.checked = false;
            if (cb.checked) return;
            const rateEl = item.querySelector('.vc-ma-item-rate');
            if (rateEl) rateEl.innerHTML = '';
          });
        };

        // Radios give the "exactly one" affordance for free, and because a radio
        // cannot be unchecked by clicking it, single mode cannot drop back to
        // zero selected once the buyer has picked a location.
        const applyInputType = (mode) => {
          list.querySelectorAll('.vc-ma-check').forEach((cb) => {
            const wasChecked = cb.checked;
            cb.type = mode === 'single' ? 'radio' : 'checkbox';
            // Name first: the restore below has to land inside the radio group,
            // or it would knock the one selected row back out of it.
            if (mode === 'single') cb.name = 'vc-ma-location';
            else cb.removeAttribute('name');
            if (cb.checked !== wasChecked) cb.checked = wasChecked;
          });
        };

        const setMode = (mode, { persist = true, summary = true } = {}) => {
          this._maMode = mode;
          modeBtns.forEach((btn) => {
            const on = btn.dataset.vcMaMode === mode;
            btn.classList.toggle('vc-ma-mode-btn--on', on);
            btn.setAttribute('aria-checked', String(on));
          });
          if (maViewEl) maViewEl.classList.toggle('vc-ma-view--single', mode === 'single');
          if (subEl) {
            subEl.textContent = mode === 'single'
              ? 'Select the location this order ships to.'
              : 'Select every location that should receive a copy of this cart.';
          }
          if (mode === 'single') {
            // "Show selected only" is hidden in single mode; leaving it pressed
            // would keep filtering a list the buyer can no longer unfilter.
            if (showSelectedBtn?.getAttribute('aria-pressed') === 'true') {
              showSelectedBtn.setAttribute('aria-pressed', 'false');
              showSelectedBtn.textContent = 'Show selected only';
            }
            // Narrowing keeps the first checked row and drops the rest, so the
            // count, the saved _locations and the cart multiplier cannot
            // disagree with what the list now shows.
            collapseToOne(list.querySelector('.vc-ma-check:checked'));
          }
          applyInputType(mode);
          const n = updateSelectionControls();
          if (summary) this._updateMaSummary(n);
          if (persist) this._saveMaSelection();
        };

        modeBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            if (btn.dataset.vcMaMode !== this._maMode) setMode(btn.dataset.vcMaMode);
          });
        });

        list.addEventListener('change', (e) => {
          const cb = e.target.closest('.vc-ma-check');
          if (!cb) return;
          if (this._maMode === 'single' && cb.checked) collapseToOne(cb);
          const n = updateSelectionControls();
          const rateEl = cb.closest('.vc-ma-item')?.querySelector('.vc-ma-item-rate');
          if (cb.checked && rateEl && !rateEl.children.length) {
            this._fetchMaRate(parseInt(cb.dataset.idx), rateEl);
          }
          this._updateMaSummary(n);
          this._saveMaSelection();
        });

        // Restore locations selected before a page refresh, from the cart attribute.
        // Just re-check the boxes — the Order Preview stays on the real single-location
        // cart totals until the user actually opens the multi-location view (openView()
        // scales it from the checked count at that point).
        let savedIds = [];
        try {
          savedIds = JSON.parse(this._maCartData?.attributes?._locations || '[]');
        } catch (_) {}
        if (Array.isArray(savedIds) && savedIds.length) {
          // _locations now holds vcMaKey values. Carts saved before that change
          // hold raw addr.id, so accept either rather than silently dropping a
          // selection the buyer made on the previous page load.
          const savedSet = new Set(savedIds.map((id) => String(id)));
          const restored = [];
          list.querySelectorAll('.vc-ma-check').forEach((cb) => {
            const addr = this._maAddresses[parseInt(cb.dataset.idx)];
            if (addr && (savedSet.has(vcMaKey(addr)) || savedSet.has(String(addr.id)))) {
              cb.checked = true;
              restored.push(cb);
            }
          });
          if (restored.length) {
            restored.forEach((cb) => {
              const rateEl = cb.closest('.vc-ma-item')?.querySelector('.vc-ma-item-rate');
              if (rateEl) this._fetchMaRate(parseInt(cb.dataset.idx), rateEl);
            });
          }
        }
        // A restored multi-location selection reopens in multi mode, so a
        // refresh does not silently collapse locations the buyer already picked.
        // Everything else starts single. persist/summary off: nothing has
        // changed yet, and the Order Preview stays on the real single-location
        // cart totals until the buyer actually opens this view (openView scales
        // it from the checked count at that point).
        setMode(this._maSelectedChecks().length > 1 ? 'multi' : 'single', { persist: false, summary: false });
      }

      // Trigger button opens the multi-addr view
      const trigger   = this.querySelector('#vc-ma-trigger');
      const cartLines = this.querySelector('[data-vc-cart-lines]');
      const maView    = this.querySelector('#vc-ma-view');
      const submitBtn = this.querySelector('#vc-ma-submit');
      const checkoutBtn = this.querySelector('#vc-checkout-link');

      const openView = () => {
        const distBanner = this.querySelector('.vc-dist-banner');
        if (distBanner) {
          distBanner.classList.remove('vc-dist-banner--show');
          distBanner.hidden = true;
        }
        if (cartLines) cartLines.hidden = true;
        if (maView)    maView.hidden    = false;
        if (trigger) {
          trigger.classList.add('vc-ma-trigger--open');
          const lbl = trigger.querySelector('.vc-ma-trigger__label');
          if (lbl) lbl.textContent = 'Back to cart items';
        }
        if (submitBtn)   submitBtn.hidden   = false;
        if (checkoutBtn) checkoutBtn.hidden = true;
        this._updateMaSummary(this._maSelectedChecks().length);
      };
      const closeView = () => {
        const distBanner = this.querySelector('.vc-dist-banner');
        if (distBanner) {
          distBanner.hidden = false;
          requestAnimationFrame(() => distBanner.classList.add('vc-dist-banner--show'));
        }
        if (cartLines) cartLines.hidden = false;
        if (maView)    maView.hidden    = true;
        if (trigger) {
          trigger.classList.remove('vc-ma-trigger--open');
          const lbl = trigger.querySelector('.vc-ma-trigger__label');
          if (lbl) lbl.textContent = 'Choose shipping address';
        }
        if (submitBtn)   submitBtn.hidden   = true;
        // Step one never exposes direct checkout. The delivery-location trigger
        // remains the only path forward for eligible B2B customers.
        if (checkoutBtn) checkoutBtn.hidden = true;
        this._updateMaSummary(0);
      };

      trigger?.addEventListener('click', () => maView.hidden ? openView() : closeView());
      submitBtn?.addEventListener('click', () => this._submitMultiAddr());

      // The normal checkout CTA uses the same step instead of silently choosing
      // customerData.defaultShipTo and sending the buyer to a second selector.
      this._openAddressStep = openView;

      // Show the trigger button
      if (trigger) trigger.hidden = false;
      return true;
    }

    // Scale the Order Preview stats/totals by the number of selected locations —
    // each selected location receives a full copy of the cart (see _submitMultiAddr).
    async _updateMaSummary(n) {
      if (!this._maCartData) {
        try {
          this._maCartData = await fetch('/cart.js').then((r) => r.json());
        } catch (_) { return; }
      }
      const cart = this._maCartData;
      const mult = Math.max(n, 1);

      const lineCount    = cart.items ? cart.items.length : 0;
      const baseUnits    = cart.item_count ?? 0;
      const baseOriginal = cart.original_total_price ?? 0;
      const baseItemsSub = cart.items_subtotal_price ?? baseOriginal;

      const itemCount = baseUnits * mult;
      const original  = baseOriginal * mult;
      const itemsSub  = baseItemsSub * mult;
      const discount  = original - itemsSub;

      const statLines = this.querySelector('[data-vc-stat-lines]');
      if (statLines) statLines.textContent = lineCount;
      const statUnits = this.querySelector('[data-vc-stat-units]');
      if (statUnits) statUnits.textContent = itemCount.toLocaleString('en-US');

      const subDisplay = this.querySelector('[data-vc-subtotal-display]');
      if (subDisplay) subDisplay.textContent = this._money(original / 100);
      const savingsRow     = this.querySelector('[data-vc-savings-row]');
      const savingsDisplay = this.querySelector('[data-vc-savings-display]');
      if (savingsRow) savingsRow.hidden = discount <= 0;
      if (savingsDisplay) savingsDisplay.textContent = '−' + this._money(discount / 100);
      const grandTotal = this.querySelector('[data-vc-grand-total]');
      if (grandTotal) grandTotal.textContent = this._money(itemsSub / 100);
    }

    // The checked locations, after collapsing rows that resolve to the same ERP
    // ship-to. Single source of truth: the buyer-facing count, the persisted
    // selection and the cart multiplier all read this, so none of them can
    // report a different number of locations than the order actually ships to.
    _maSelectedChecks() {
      const seen = new Set();
      const out  = [];
      this.querySelectorAll('#vc-ma-list .vc-ma-check:checked').forEach((cb) => {
        const addr = this._maAddresses?.[parseInt(cb.dataset.idx)];
        if (!addr) return;
        const key = vcMaKey(addr);
        if (!key || seen.has(key)) return;
        seen.add(key);
        out.push({ cb, addr, key });
      });
      return out;
    }

    // Persist the checked locations to a cart attribute so they survive a page refresh.
    _saveMaSelection() {
      // The credit summary follows the selection immediately; the cart
      // attributes follow it on the same debounce as _locations.
      this._renderCreditMemoSummary();
      clearTimeout(this._maSaveTimeout);
      this._maSaveTimeout = setTimeout(() => {
        const keys = this._maSelectedChecks().map(({ key }) => key);
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { _locations: JSON.stringify(keys) } }),
        }).catch(() => {});
        this._syncCreditMemo();
      }, 400);
    }

    async _submitMultiAddr() {
      const btn = this.querySelector('#vc-ma-submit');
      if (btn) btn.dataset.loading = '';
      // Drop any debounced _saveMaSelection still pending: both branches below
      // write _locations themselves, and a late fire-and-forget write could
      // otherwise land after them or be abandoned by the navigation.
      clearTimeout(this._maSaveTimeout);
      try {
        const cart = await vcRemoveZeroPriceLines();
        if (!cart.items?.length) { window.location.reload(); return; }

        // Build variantId → qty and variantId → line item hash maps
        const items = {};
        cart.items.forEach(item => { items[String(item.variant_id)] = item.quantity; });

        // Same deduped selection the button label and _locations were built
        // from, so the multiplier below cannot disagree with either.
        const selected = this._maSelectedChecks().map(({ cb, addr }) => {
          const rateSelect = cb.closest('.vc-ma-item')?.querySelector('.vc-ma-rate-select');
          let erp = {};
          if (rateSelect) try { erp = JSON.parse(rateSelect.options[rateSelect.selectedIndex]?.dataset.erp || '{}'); } catch(_) {}
          return { addr, erp };
        });
        if (selected.length < 1) return;

        // Resolve per-address base quantities. _maCartData holds the cart snapshot from
        // when rates were fetched — before any scaling.
        let baseItems = { ...items };
        if (this._maCartData?.items) {
          const base = {};
          // The snapshot predates the $0 removal above; without this filter a
          // removed line would fail the check below and drop the base entirely.
          this._maCartData.items.forEach(i => {
            if (i.original_price !== 0) base[String(i.variant_id)] = i.quantity;
          });
          if (Object.keys(base).every(vid => vid in items)) baseItems = base;
        }

        // Inventory check using base (per-address) quantities
        const shortages = [];
        document.querySelectorAll('[data-vc-line][data-inventory]').forEach(line => {
          const key    = line.getAttribute('data-key');
          const maxInv = parseInt(line.getAttribute('data-inventory'), 10);
          // Fall back to variant_id: data-key is Liquid-rendered and goes stale
          // whenever the server cart changed after paint. Now that this check is
          // the only thing standing between a shortage and a clamped cart, a
          // missed match has to not silently skip the line.
          const cartItem = cart.items.find(i => i.key === key)
            || cart.items.find(i => String(i.variant_id) === line.getAttribute('data-variant-id'));
          if (!cartItem || isNaN(maxInv)) return;
          const vid   = String(cartItem.variant_id);
          const total = (baseItems[vid] ?? cartItem.quantity) * selected.length;
          if (total > maxInv) {
            shortages.push({
              title:     cartItem.product_title || cartItem.title,
              variant:   cartItem.variant_title && cartItem.variant_title !== 'Default Title' ? cartItem.variant_title : '',
              requested: total,
              available: maxInv,
            });
          }
        });
        if (shortages.length) {
          // Hard stop — the cart is never scaled past available stock.
          if (btn) delete btn.dataset.loading;
          await this._showMaShortageDialog(shortages);
          return;
        }

        // Built from the same selection as _order, so each memo is bound to a
        // location that is actually on this order and to its copy count.
        const creditMemoAttrs = this._creditMemoAttributes();
        this._creditMemoWritten = this._creditMemoStateKey(creditMemoAttrs);

        // Same _order structure as cart-distribution — one entry per address, full cart items each
        const orderAttr = selected.map(({ addr: a, erp }) => ({
          id:          a.bcSystemId   || a.id,
          ...erp,
          bc_customer: a.bcCustomerNo || '',
          bc_ship_to:  a.bcShipToCode || '',
          addr:        a.addr         || '',
          contact:     { name: a.contact || '', phone: a.phone || '' },
          items:       { ...baseItems },
          credit_memo: this._creditMemoApplied(creditMemoAttrs, a.bcCustomerNo || ''),
        }));
        const addressAttr = selected.map(({ addr: a }) => ({
          id:          a.bcSystemId   || a.id,
          bc_customer: a.bcCustomerNo || '',
          bc_ship_to:  a.bcShipToCode || '',
          company:     a.name         || '',
          address:     a.address1     || '',
          address2:    a.address2     || '',
          city:        a.city         || '',
          contact:     a.contact      || '',
          phone:       a.phone        || '',
          country:     a.country      || '',
          zip:         a.zip          || '',
          state:       a.state        || '',
        }));

        // Scale cart quantities: each variant × number of selected addresses
        const updates = {};
        Object.entries(baseItems).forEach(([vid, qty]) => { updates[vid] = qty * selected.length; });

        const auth = window.__vaAuth;
        const variantKey = Object.entries(updates)
          .filter(([, qty]) => qty > 0)
          .map(([vid, qty]) => `${vid}:${qty}`)
          .sort()
          .join(',');

        if (selected.length === 1) {
          // Keep the original single-address order contract. Only the chosen
          // ship-to values differ from the old defaultShipTo-based payload.
          const a = selected[0].addr;
          const customerData = await window.__vaCustomerInfo;
          const erpNo = customerData?.No || customerData?.no || '';
          const singleOrderAttr = [{
            id:          a.bcSystemId   || a.id,
            bc_customer: a.bcCustomerNo || '',
            bc_ship_to:  a.bcShipToCode || '',
            addr:        a.addr         || '',
            contact:     { name: a.contact || '', phone: a.phone || '' },
            items:       { ...baseItems },
            credit_memo: this._creditMemoApplied(creditMemoAttrs, a.bcCustomerNo || ''),
          }];

          const [attrRes] = await Promise.all([
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                attributes: {
                  '_address_type': JSON.stringify({
                    type: this._maAddresses.length === 1 ? 'single' : 'multiple',
                    company_location_id: window.__vaCurrentCompanyLocationId || '',
                    bc_customer: erpNo,
                    address_count: this._maAddresses.length,
                  }),
                  '_order':     JSON.stringify(singleOrderAttr),
                  '_address':   JSON.stringify(addressAttr),
                  '_lineitems': '',
                  '_scaled':    '',
                  '_locations': JSON.stringify([vcMaKey(a)].filter(Boolean)),
                  ...creditMemoAttrs,
                },
              }),
            }).catch(() => null),
            (auth && variantKey) ? fetch(auth.proxy, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                action: 'clear-shipping-total', customer_id: auth.customer_id,
                ts: auth.ts, token: auth.token, shop: Shopify.shop, variant_key: variantKey,
              }),
            }).catch(() => {}) : Promise.resolve(),
          ]);
          await this._requireSavedOrder(attrRes);
          await this._syncCompanyLocationShipping(a);
        } else {
          const totalShippingCents = Math.round(
            selected.reduce((s, { erp }) => s + (erp.buyer ?? 0), 0) * 100
          );

          // 0. Point the shared Company Location at the first selected address
          //    so checkout shows one of this order's own ship-tos instead of a
          //    colleague's last one. Done before scaling so a failure leaves
          //    the cart untouched. The pre-calculated rate below is keyed on
          //    customer + cart contents, not destination, so it still applies.
          await this._syncCompanyLocationShipping(selected[0].addr);

          // 1. Scale the cart first. Everything below is derived from what the
          //    cart actually became rather than from what we asked for, so no
          //    later step can be silently wrong about the real quantities.
          const scaleRes = await fetch('/cart/update.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({ updates }),
          });
          if (!scaleRes.ok) throw new Error('We couldn\u2019t update your cart quantities. Please try again.');
          const scaledCart = await scaleRes.json();

          // 2. shipping.php rebuilds this key from the carrier-service payload,
          //    which carries one entry per LINE ITEM rather than per variant, so
          //    mirror that shape against the real cart. Building it from
          //    `updates` meant any divergence — an inventory clamp, an app
          //    touching the cart — missed the saved file and fell through to a
          //    single-destination ERP quote against the native address.
          const actualVariantKey = (scaledCart.items || [])
            .map(i => `${i.variant_id}:${i.quantity}`)
            .sort()
            .join(',');
          if (auth && actualVariantKey) {
            await fetch(auth.proxy, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                customer_id:    auth.customer_id,
                ts:             auth.ts,
                token:          auth.token,
                shop:           Shopify.shop,
                action:         'save-shipping-total',
                variant_key:    actualVariantKey,
                shipping_total: totalShippingCents,
              }),
            });
          }

          // 3. Bust Shopify's carrier-service rate cache, the way the
          //    distribution page's direct path does. That cache is keyed on cart
          //    contents plus destination, and in this branch the destination is
          //    always the native Company Location address — so two different
          //    location selections that scale to identical quantities (four
          //    stores swapped for four others, or a different service picked)
          //    would otherwise be served the first total. Touching a line item
          //    property moves the cache key without touching quantities, so the
          //    key saved in step 2 stays valid. It also invalidates anything
          //    Shopify may have cached from a rate request racing step 1.
          let finalCart = scaledCart;
          const bustLine = scaledCart.items?.[(scaledCart.items?.length || 1) - 1];
          if (bustLine) {
            try {
              const bustRes = await fetch('/cart/change.js', {
                method:  'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id:         bustLine.key,
                  quantity:   bustLine.quantity,
                  properties: { ...bustLine.properties, _dist_v: Date.now() },
                }),
              });
              if (bustRes.ok) finalCart = await bustRes.json();
            } catch (_) { /* a missed bust costs a stale rate, not a broken cart */ }
          }

          // 4. Attributes last. _lineitems is a map of line item key hashes, so it
          //    has to come from the FINAL cart — the bust above went through
          //    /cart/change.js, which rehashes keys.
          //
          //    _scaled deliberately does NOT use line item keys. That hash covers
          //    properties and discount allocation, so it moves under the bust and
          //    again whenever checkout recalculates discounts — which left the
          //    cart page unable to match a single line. Variant id is stable, and
          //    it is the same granularity the scaling itself uses (`updates` is
          //    variant-keyed), so it is exactly as precise as what it reverses.
          const finalLineitems = {};
          (finalCart.items || []).forEach(i => {
            const colon = i.key.indexOf(':');
            if (colon !== -1) finalLineitems[String(i.variant_id)] = i.key.slice(colon + 1);
          });
          const scaledBase = {};
          Object.entries(baseItems).forEach(([vid, qty]) => {
            if (qty != null) scaledBase[vid] = qty;
          });

          const attrRes = await fetch('/cart/update.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: {
                '_order':     JSON.stringify(orderAttr),
                '_address':   JSON.stringify(addressAttr),
                '_lineitems': JSON.stringify(finalLineitems),
                '_scaled':    JSON.stringify({ n: selected.length, items: scaledBase }),
                '_locations': JSON.stringify(selected.map(({ addr: a }) => vcMaKey(a)).filter(Boolean)),
                ...creditMemoAttrs,
              },
            }),
          }).catch(() => null);
          // Step 1 already multiplied the quantities. If _order did not save,
          // put them back first: without the _scaled marker a reload would take
          // the inflated cart as the base and scale it again on the next try.
          await this._requireSavedOrder(attrRes, baseItems);
        }

        if (btn) delete btn.dataset.loading;
        if (selected.length === 1) {
          window.location.href = this.querySelector('#vc-checkout-link')?.href || '/checkout';
        } else {
          window.location.href = '/checkout';
        }
      } catch (err) {
        if (btn) delete btn.dataset.loading;
        // The credit attributes may not have saved with the rest.
        this._creditMemoWritten = null;
        vcAlert(err.message || 'Failed to prepare multi-address order.');
      }
    }

    // Blocking notice, not a choice. Proceeding past a shortage let
    // /cart/update.js clamp a line to available stock, which desynced three
    // things at once: _order kept asking for base x locations while the cart
    // held less, and the pre-calculated shipping variant_key — built from the
    // intended quantities — no longer matched the real cart, so checkout fell
    // back to a single-destination ERP quote. The buyer has to reduce the
    // order or talk to their account manager instead.
    _showMaShortageDialog(shortages) {
      return new Promise(resolve => {
        const overlay = document.createElement('div');
        overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.35);z-index:9999;display:flex;align-items:center;justify-content:center;';
        const listHtml = shortages.map(s => {
          const label = [s.title, s.variant].filter(Boolean).join(' \u2013 ');
          return `<li><strong>${label}</strong>: ${s.requested} needed, ${s.available} available</li>`;
        }).join('');
        overlay.innerHTML = `
          <div style="background:#fff;border-radius:12px;padding:24px;max-width:420px;width:90%;box-shadow:0 8px 32px rgba(0,0,0,0.18);">
            <h3 style="margin:0 0 10px;font-size:16px;font-weight:600;color:#1D2636;">Insufficient Inventory</h3>
            <p style="margin:0 0 12px;font-size:13px;color:#2B3A55;line-height:1.5;">The following item${shortages.length > 1 ? 's don\u2019t' : ' doesn\u2019t'} have enough stock for all selected addresses:</p>
            <ul style="margin:0 0 16px;padding-left:20px;font-size:13px;color:#2B3A55;line-height:1.7;">${listHtml}</ul>
            <p style="margin:0 0 20px;font-size:12px;color:#66717E;">Please lower the quantities in your cart or select fewer delivery locations. Need the full quantity? Your Valor account manager may be able to source more stock or split the delivery.</p>
            <div style="display:flex;justify-content:flex-end;">
              <button id="vc-ma-inv-close" style="padding:8px 16px;border:none;border-radius:6px;background:#1D2636;color:#fff;font-size:13px;cursor:pointer;">Adjust my order</button>
            </div>
          </div>
        `;
        document.body.appendChild(overlay);
        const close = () => { overlay.remove(); resolve(); };
        overlay.querySelector('#vc-ma-inv-close').addEventListener('click', close);
        overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
      });
    }

    // ── Multi-address shipping rates ─────────────────────
    async _fetchMaRate(idx, rateEl) {
      const auth = window.__vaAuth;
      if (!auth || !rateEl) return;
      const a = this._maAddresses[idx];
      if (!a) return;

      const submitBtn = this.querySelector('#vc-ma-submit');
      if (submitBtn) submitBtn.disabled = true;
      rateEl.innerHTML = '<span class="vc-ma-rate-loading">Loading…</span>';

      if (!this._maCartData) {
        try {
          const r = await fetch('/cart.js');
          this._maCartData = await r.json();
        } catch(_) { this._maCartData = { total_price: 0, items: [] }; }
      }
      const subtotal = (this._maCartData.original_total_price ?? this._maCartData.total_price ?? 0) / 100;
      const weight   = (this._maCartData.items || []).reduce((s, i) => s + (i.grams || 0) * (i.quantity || 0), 0) / 453.592;

      try {
        const resp = await fetch(auth.proxy, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop,
            action: 'checkout-options',
            subtotal, weight: weight || 0.01,
            ship_to: {
              name:     a.name     || '',
              address1: a.address1 || '',
              address2: a.address2 || '',
              city:     a.city     || '',
              state:    a.state    || '',
              zip:      a.zip      || '',
              country:  a.country  || 'US',
              phone:    a.phone    || '',
            }
          })
        });
        const result = await resp.json();
        if (!result.ok) throw new Error(result.error || 'API error');

        const rates = (result.data?.rateOptions || []).filter(r => {
          if (r.errorMessages?.length) return false;
          const name = (r.serviceDisplayName || ((r.carrierFriendlyName || '') + ' ' + (r.serviceCode || ''))).toLowerCase();
          return !name.includes('pickup');
        });

        if (!rates.length) { rateEl.textContent = 'No rates'; return; }

        const select = document.createElement('select');
        select.className = 'vc-ma-rate-select';
        for (const rate of rates) {
          const price = rate.buyerFreightChargeLCY ?? rate.amount ?? 0;
          const name  = rate.serviceDisplayName || ((rate.carrierFriendlyName || '') + ' ' + (rate.serviceCode || '')).trim();
          const opt   = document.createElement('option');
          opt.value       = price;
          opt.dataset.erp = JSON.stringify({
            agent:    rate.bcShippingAgentCode        ?? null,
            service:  rate.bcShippingAgentServiceCode ?? null,
            buyer:    rate.buyerFreightChargeLCY      ?? null,
            estimate: rate.estimatedFreightLCY        ?? null,
            quote:    rate.quotedFreightChargeLCY     ?? null,
            free:     rate.isFreeShipping             ?? false,
            fixed:    rate.isFixedFreightCharge       ?? false,
          });
          opt.textContent = price == 0 ? 'Free — ' + name : '$' + Number(price).toFixed(2) + ' — ' + name;
          select.appendChild(opt);
        }
        rateEl.innerHTML = '';
        rateEl.appendChild(select);
      } catch(err) {
        let msg = err.message.replace(/^HTTP \d+ - /, '').replace(/^[^:]+:\s*/, '').replace(/\s*\([^)]+\)\s*$/, '').trim();
        rateEl.innerHTML = '<em class="vc-ma-rate-err">' + msg + '</em>';
      } finally {
        // Re-enable submit once all in-flight rate loads are done
        if (submitBtn) {
          const anyLoading = this.querySelector('#vc-ma-list .vc-ma-rate-loading');
          const n = this._maSelectedChecks().length;
          submitBtn.disabled = !!(anyLoading || n < 1);
        }
      }
    }

    // ── Net terms ────────────────────────────────────────
    async _initNetTerms() {
      const row  = document.getElementById('vc-net-terms');
      // Only for companies approved for NET (see net_terms_enabled in the Liquid).
      if (!row || row.dataset.netEnabled !== 'true') return;
      if (!window.__vaCustomerInfo) return;
      const data = await window.__vaCustomerInfo;
      const terms = String(data?.paymentTermsCode || data?.PaymentTermsCode || '').trim();
      // "NET 0" means payment is due now, not terms.
      if (!terms || /^(net\s*)?0$/i.test(terms)) return;
      const code = document.getElementById('vc-terms-code');
      if (code) code.textContent = terms;
      if (row)  row.style.display = '';
    }
  }

  customElements.define('valor-cart-page', ValorCartPage);

  // Reload on bfcache restore — Liquid-rendered data-key values go stale when the server cart
  // is modified (e.g. multi-address quantity scaling) before the user navigates away.
  // Must be at script level, not in connectedCallback, because connectedCallback doesn't run on bfcache restore.
  window.addEventListener('pageshow', (e) => { if (e.persisted) window.location.reload(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-category"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.vr-cat-scroll-wrap').forEach(wrap => {
  const grid = wrap.querySelector('.vr-cat-grid');
  const prev = wrap.querySelector('.vr-cat-nav--prev');
  const next = wrap.querySelector('.vr-cat-nav--next');
  if (!grid || !prev || !next) return;

  function update() {
    prev.hidden = grid.scrollLeft <= 1;
    next.hidden = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 1;
  }

  prev.addEventListener('click', () => grid.scrollBy({ left: -grid.clientWidth * 0.8, behavior: 'smooth' }));
  next.addEventListener('click', () => grid.scrollBy({ left: grid.clientWidth * 0.8, behavior: 'smooth' }));
  grid.addEventListener('scroll', update, { passive: true });
  update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-coming-soon"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var products = window.__csProducts || [];
  var state = { date: 'all' };

  var TODAY = new Date();
  TODAY.setHours(0, 0, 0, 0);

  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function parseD(iso) { return new Date(iso + 'T00:00:00'); }
  function fShort(d) { return MON[d.getMonth()] + ' ' + d.getDate(); }
  function fNum(d) { return (d.getMonth() + 1) + '/' + d.getDate(); }
  function fmtMoney(cents) { return '$' + (cents / 100).toFixed(2); }

  function escHtml(s) {
    return String(s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  // Collect distinct future dates across all products
  function buildBuckets() {
    var map = {};
    products.forEach(function (p) {
      var dates = p.next_arrival;
      if (!dates) return;
      // next_arrival may be an array or a single string
      if (!Array.isArray(dates)) dates = [dates];
      dates.forEach(function (iso) {
        if (!iso) return;
        var d = parseD(iso);
        if (d < TODAY) return; // skip past dates
        if (!map[iso]) map[iso] = [];
        map[iso].push(p);
      });
    });
    var sorted = Object.keys(map).sort();
    return sorted.map(function (iso) { return { date: iso, products: map[iso] }; });
  }

  // Earliest future arrival date for a product (for card ETA display)
  function getEta(p) {
    var dates = p.next_arrival;
    if (!dates) return null;
    if (!Array.isArray(dates)) dates = [dates];
    var future = dates.filter(function (iso) { return iso && parseD(iso) >= TODAY; });
    future.sort();
    return future.length ? future[0] : null;
  }

  function renderFilter(buckets) {
    var inner = document.getElementById('cs-flt-inner');
    if (!inner) return;
    var pills = '<button class="cs-dp-all' + (state.date === 'all' ? ' active' : '') + '" data-date="all">All dates</button>';
    buckets.forEach(function (b) {
      var active = state.date === b.date;
      pills += '<span class="cs-dgrp' + (active ? ' active' : '') + '">'
        + '<button class="cs-dg-date" data-date="' + escHtml(b.date) + '">' + escHtml(fShort(parseD(b.date))) + '</button>'
        + '</span>';
    });
    inner.innerHTML = '<span class="cs-flt-lbl">Expected arrival date</span>'
      + '<div class="cs-flt-pills">' + pills + '</div>';
  }

  function card(p) {
    var eta = getEta(p);
    var imgHtml = p.image
      ? '<img src="' + escHtml(p.image) + '" alt="' + escHtml(p.title) + '" loading="lazy">'
      : '<svg class="cs-ic-img-empty" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><rect x="6" y="2" width="12" height="20" rx="2.5"/><path d="M11 19h2"/></svg>';

    return '<a href="' + escHtml(p.url) + '" class="cs-card">'
      + '<div class="cs-ic-img">'
      + imgHtml
      + '<div class="cs-ic-badges"><span class="cs-ic-badge soon">Coming Soon</span></div>'
      + '</div>'
      + '<div class="cs-ic-info">'
      + '<div class="cs-ic-brand">' + escHtml(p.vendor) + '</div>'
      + '<div class="cs-ic-name">' + escHtml(p.title) + '</div>'
      + (p.sku ? '<div class="cs-ic-sku">' + escHtml(p.sku) + '</div>' : '')
      + '<div class="cs-ic-price">'
      + '<div><div class="cs-ic-wholesale">Your price</div><div class="cs-ic-amount">' + fmtMoney(p.price) + '</div></div>'
      + '</div>'
      + (eta ? '<div class="cs-ic-stock eta"><span class="dot"></span>ETA ' + escHtml(fNum(parseD(eta))) + '</div>' : '')
      + '<div class="cs-ic-action">'
      + '<button class="cs-ic-notify-btn" onclick="event.preventDefault()">'
      + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M13.7 21a2 2 0 0 1-3.4 0"/></svg>'
      + 'Notify Me When Available'
      + '</button>'
      + '</div>'
      + '</div>'
      + '</a>';
  }

  function getVisible(buckets) {
    if (state.date === 'all') {
      var seen = {};
      var result = [];
      buckets.forEach(function (b) {
        b.products.forEach(function (p) {
          if (!seen[p.id]) { seen[p.id] = true; result.push(p); }
        });
      });
      return result;
    }
    var bucket = null;
    buckets.forEach(function (b) { if (b.date === state.date) bucket = b; });
    return bucket ? bucket.products : [];
  }

  function render() {
    var buckets = buildBuckets();
    renderFilter(buckets);

    var stage = document.getElementById('cs-stage');
    if (!stage) return;

    var visible = getVisible(buckets);

    if (!visible.length) {
      var msg = buckets.length === 0
        ? 'No upcoming arrivals found. Add <code>custom.next_arrival</code> dates to products in this collection.'
        : 'No products for this date.';
      stage.innerHTML = '<div class="cs-empty">' + msg + '</div>';
      return;
    }

    stage.innerHTML = '<div class="cs-grid">' + visible.map(card).join('') + '</div>';
  }

  // Filter click (delegated)
  var inner = document.getElementById('cs-flt-inner');
  if (inner) {
    inner.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-date]');
      if (!btn) return;
      state.date = btn.getAttribute('data-date');
      render();
    });
  }

  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valor-desktop-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  var items = document.querySelectorAll('.vdn__item--dd');

  items.forEach(function (item) {
    var trigger = item.querySelector('.vdn__trigger');
    if (!trigger) return;

    // Keep aria-expanded in sync with CSS hover state
    item.addEventListener('mouseenter', function () {
      trigger.setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('mouseleave', function () {
      trigger.setAttribute('aria-expanded', 'false');
    });

    // Click: close others, toggle this (keyboard / touch support)
    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      items.forEach(function (other) {
        if (other !== item) {
          var t = other.querySelector('.vdn__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });

  // Escape closes all
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    items.forEach(function (item) {
      var t = item.querySelector('.vdn__trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  // Click outside closes all
  document.addEventListener('click', function (e) {
    if (e.target.closest('.vdn__item--dd')) return;
    items.forEach(function (item) {
      var t = item.querySelector('.vdn__trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  document.querySelectorAll('.vdn__mega--designlab').forEach(function (menu) {
    var railItems = menu.querySelectorAll('.vdn__dl-rail-item');
    var panels = menu.querySelectorAll('.vdn__dl-panel');

    function activate(category) {
      railItems.forEach(function (button) {
        var active = button.getAttribute('data-vdn-dlcat') === category;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-vdn-dlpanel') === category;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    railItems.forEach(function (button) {
      var category = button.getAttribute('data-vdn-dlcat');
      button.addEventListener('mouseenter', function () { activate(category); });
      button.addEventListener('focus', function () { activate(category); });
      button.addEventListener('click', function (event) {
        event.preventDefault();
        activate(category);
      });
    });
  });

})();

  } catch(e) { console.error(e); }
})();
})();
